export const ending_underlying = {
    "[Abl]": [
        ".ken"
    ],
    "[Abl_Mod][DuUnpd]": [
        ".gnek"
    ],
    "[Abl_Mod][PlUnpd]": [
        ".nek"
    ],
    "[Abl_Mod][SgUnpd]": [
        ".mek"
    ],
    "[Abs][DuUnpd]": [
        ".k"
    ],
    "[Abs][PlUnpd]": [
        ".t"
    ],
    "[Abs][SgUnpd]": [
        "+na",
        "+n'a"
    ],
    "[Equ]": [
        ".ten"
    ],
    "[Equ][DuUnpd]": [
        ".gcetun"
    ],
    "[Equ][PlUnpd]": [
        ".cetun"
    ],
    "[Equ][SgUnpd]": [
        ".tun"
    ],
    "[Loc]": [
        ".ni"
    ],
    "[Loc][DuUnpd]": [
        ".gni"
    ],
    "[Loc][PlUnpd]": [
        ".ni"
    ],
    "[Loc][SgUnpd]": [
        ".mi"
    ],
    "[Cardinal][Sg]": [
        ""
    ],
    "[Cardinal][Du]": [
        ""
    ],
    "[Cardinal][Pl]": [
        ""
    ],
    "[N][Abl_Mod][1DuPoss][DuPosd]": [
        "%:(e)gmegnek",
        "%:(e)gmegneng"
    ],
    "[N][Abl_Mod][1DuPoss][PlPosd]": [
        "–megnek",
        "–megneng"
    ],
    "[N][Abl_Mod][1DuPoss][SgPosd]": [
        "–megnek",
        "–megneng"
    ],
    "[N][Abl_Mod][1PlPoss][DuPosd]": [
        "%:(e)gemten̄ek",
        "%:(e)gemten̄eng"
    ],
    "[N][Abl_Mod][1PlPoss][PlPosd]": [
        "–mten̄ek",
        "–mten̄eng"
    ],
    "[N][Abl_Mod][1PlPoss][SgPosd]": [
        "–mten̄ek",
        "–mten̄eng"
    ],
    "[N][Abl_Mod][1SgPoss][DuPosd]": [
        "%:(e)gemnek",
        "%:(e)gemneng"
    ],
    "[N][Abl_Mod][1SgPoss][PlPosd]": [
        "–mnek",
        "–mneng"
    ],
    "[N][Abl_Mod][1SgPoss][SgPosd]": [
        "–mnek",
        "–mneng"
    ],
    "[N][Abl_Mod][2DuPoss][DuPosd]": [
        "%:(e)gpetegnek",
        "%:(e)gpetegneng"
    ],
    "[N][Abl_Mod][2DuPoss][PlPosd]": [
        "–vtegnek",
        "–vtegneng",
        ".vtegnek",
        ".vtegneng",
        "+petegnek",
        "+petegneng"
    ],
    "[N][Abl_Mod][2DuPoss][SgPosd]": [
        "–vtegnek",
        "–vtegneng",
        ".vtegnek",
        ".vtegneng",
        "+petegnek",
        "+petegneng"
    ],
    "[N][Abl_Mod][2PlPoss][DuPosd]": [
        "%:(e)gpecen̄ek",
        "%:(e)gpecineng"
    ],
    "[N][Abl_Mod][2PlPoss][PlPosd]": [
        "–vcineng",
        "–vcen̄ek",
        ".vcineng",
        ".vcen̄ek",
        "+pecineng",
        "+pecen̄ek"
    ],
    "[N][Abl_Mod][2PlPoss][SgPosd]": [
        "–vcineng",
        "–vcen̄ek",
        ".vcineng",
        ".vcen̄ek",
        "+pecineng",
        "+pecen̄ek"
    ],
    "[N][Abl_Mod][2SgPoss][DuPosd]": [
        "%:(e)gpenek",
        "%:(e)gpeneng"
    ],
    "[N][Abl_Mod][2SgPoss][PlPosd]": [
        "–vnek",
        "–vneng",
        ".vnek",
        ".vneng",
        "+penek",
        "+peneng"
    ],
    "[N][Abl_Mod][2SgPoss][SgPosd]": [
        "–vnek",
        "–vneng",
        ".vnek",
        ".vneng",
        "+penek",
        "+peneng"
    ],
    "[N][Abl_Mod][3DuPoss][DuPosd]": [
        "%:(e)gkegni",
        "%:(e)gkegneng"
    ],
    "[N][Abl_Mod][3DuPoss][PlPosd]": [
        "–kegnek",
        "–kegneng"
    ],
    "[N][Abl_Mod][3DuPoss][SgPosd]": [
        ":(ng)agnek",
        ":(ng)agneng"
    ],
    "[N][Abl_Mod][3PlPoss][DuPosd]": [
        "%:(e)gketnek",
        "%:(e)gketneng"
    ],
    "[N][Abl_Mod][3PlPoss][PlPosd]": [
        ":(ng)itnek",
        ":(ng)itneng"
    ],
    "[N][Abl_Mod][3PlPoss][SgPosd]": [
        ":(ng)atnek",
        ":(ng)atneng"
    ],
    "[N][Abl_Mod][3SgPoss][DuPosd]": [
        "%:(e)gkenek",
        "%:(e)gkeneng"
    ],
    "[N][Abl_Mod][3SgPoss][PlPosd]": [
        ":(ng)inek",
        ":(ng)ineng"
    ],
    "[N][Abl_Mod][3SgPoss][SgPosd]": [
        ":(ng)anek",
        ":(ng)aneng"
    ],
    "[N][Abl_Mod][4DuPoss][DuPosd]": [
        "%:(e)gmegnek",
        "%:(e)gmegneng"
    ],
    "[N][Abl_Mod][4DuPoss][PlPosd]": [
        "–megnek",
        "–megneng"
    ],
    "[N][Abl_Mod][4DuPoss][SgPosd]": [
        "–megnek",
        "–megneng"
    ],
    "[N][Abl_Mod][4PlPoss][DuPosd]": [
        "%:(e)gmeggnek",
        "%:(e)gmeggneng"
    ],
    "[N][Abl_Mod][4PlPoss][PlPosd]": [
        "–meggnek",
        "–meggneng"
    ],
    "[N][Abl_Mod][4PlPoss][SgPosd]": [
        "–meggnek",
        "–meggneng"
    ],
    "[N][Abl_Mod][4SgPoss][DuPosd]": [
        "%:(e)gminek",
        "%:(e)gmineng"
    ],
    "[N][Abl_Mod][4SgPoss][PlPosd]": [
        "–minek",
        "–mineng"
    ],
    "[N][Abl_Mod][4SgPoss][SgPosd]": [
        "–minek",
        "–mineng"
    ],
    "[N][Abl_Mod][DuUnpd]": [
        "%:(e)gnek",
        "%:(e)gneng"
    ],
    "[N][Abl_Mod][PlUnpd]": [
        "%~nek",
        "%~neng"
    ],
    "[N][Abl_Mod][SgUnpd]": [
        "%~mek",
        "%~meng"
    ],
    "[N][Abs][1DuPoss][DuPosd]": [
        "%:(e)gpuk"
    ],
    "[N][Abs][1DuPoss][PlPosd]": [
        "–puk"
    ],
    "[N][Abs][1DuPoss][SgPosd]": [
        "–puk",
        ".vuk",
        "+puk"
    ],
    "[N][Abs][1PlPoss][DuPosd]": [
        "%:(e)gput"
    ],
    "[N][Abs][1PlPoss][PlPosd]": [
        "–put"
    ],
    "[N][Abs][1PlPoss][SgPosd]": [
        "–put",
        ".vut",
        "+put"
    ],
    "[N][Abs][1SgPoss][DuPosd]": [
        "%:(e)gka"
    ],
    "[N][Abs][1SgPoss][PlPosd]": [
        "%:(e)nka"
    ],
    "[N][Abs][1SgPoss][SgPosd]": [
        "–ka"
    ],
    "[N][Abs][2DuPoss][DuPosd]": [
        "%:(e)gtek"
    ],
    "[N][Abs][2DuPoss][PlPosd]": [
        "–tek"
    ],
    "[N][Abs][2DuPoss][SgPosd]": [
        "–tek",
        "+tek",
        ".sek"
    ],
    "[N][Abs][2PlPoss][DuPosd]": [
        "%:(e)gci"
    ],
    "[N][Abs][2PlPoss][PlPosd]": [
        "–ci"
    ],
    "[N][Abs][2PlPoss][SgPosd]": [
        "–ci",
        "+ci",
        ".si"
    ],
    "[N][Abs][2SgPoss][DuPosd]": [
        "%:(e)gken"
    ],
    "[N][Abs][2SgPoss][PlPosd]": [
        "–ten"
    ],
    "[N][Abs][2SgPoss][SgPosd]": [
        "%:(e)n"
    ],
    "[N][Abs][3DuPoss][DuPosd]": [
        "%:(e)gkek"
    ],
    "[N][Abs][3DuPoss][PlPosd]": [
        "–kek"
    ],
    "[N][Abs][3DuPoss][SgPosd]": [
        ":(ng)ak"
    ],
    "[N][Abs][3PlPoss][DuPosd]": [
        "%:(e)gket"
    ],
    "[N][Abs][3PlPoss][PlPosd]": [
        ":(ng)it"
    ],
    "[N][Abs][3PlPoss][SgPosd]": [
        ":(ng)at"
    ],
    "[N][Abs][3SgPoss][DuPosd]": [
        "%:(e)k"
    ],
    "[N][Abs][3SgPoss][PlPosd]": [
        ":(ng)i"
    ],
    "[N][Abs][3SgPoss][SgPosd]": [
        ":(ng)a"
    ],
    "[N][Abs][4DuPoss][DuPosd]": [
        "%:(e)gtek"
    ],
    "[N][Abs][4DuPoss][PlPosd]": [
        "–tek"
    ],
    "[N][Abs][4DuPoss][SgPosd]": [
        "–tek",
        "+tek",
        ".sek"
    ],
    "[N][Abs][4PlPoss][DuPosd]": [
        "%:(e)gteng"
    ],
    "[N][Abs][4PlPoss][PlPosd]": [
        "–teng"
    ],
    "[N][Abs][4PlPoss][SgPosd]": [
        "–teng",
        "+teng",
        ".seng"
    ],
    "[N][Abs][4SgPoss][DuPosd]": [
        "%:(e)gni"
    ],
    "[N][Abs][4SgPoss][PlPosd]": [
        "–ni"
    ],
    "[N][Abs][4SgPoss][SgPosd]": [
        "–ni"
    ],
    "[N][Abs][DuUnpd]": [
        "%:(e)k"
    ],
    "[N][Abs][PlUnpd]": [
        "%:(e)t"
    ],
    "[N][Abs][SgUnpd]": [
        ""
    ],
    "[N][Equ][1DuPoss][DuPosd]": [
        "%:(e)gmegtun"
    ],
    "[N][Equ][1DuPoss][PlPosd]": [
        "–megtun"
    ],
    "[N][Equ][1DuPoss][SgPosd]": [
        "–megtun"
    ],
    "[N][Equ][1PlPoss][DuPosd]": [
        "%:(e)gemcetun"
    ],
    "[N][Equ][1PlPoss][PlPosd]": [
        "–mcetun"
    ],
    "[N][Equ][1PlPoss][SgPosd]": [
        "–mcetun"
    ],
    "[N][Equ][1SgPoss][DuPosd]": [
        "%:(e)gemtun"
    ],
    "[N][Equ][1SgPoss][PlPosd]": [
        "–mtun"
    ],
    "[N][Equ][1SgPoss][SgPosd]": [
        "–mtun"
    ],
    "[N][Equ][2DuPoss][DuPosd]": [
        "%:(e)gpetegtun"
    ],
    "[N][Equ][2DuPoss][PlPosd]": [
        "–vtegtun",
        ".vtegtun",
        "+petegtun"
    ],
    "[N][Equ][2DuPoss][SgPosd]": [
        "–vtegtun",
        ".vtegtun",
        "+petegtun"
    ],
    "[N][Equ][2PlPoss][DuPosd]": [
        "%:(e)gpecetun"
    ],
    "[N][Equ][2PlPoss][PlPosd]": [
        "–vcetun",
        ".vcetun",
        "+pecetun"
    ],
    "[N][Equ][2PlPoss][SgPosd]": [
        "–vcetun",
        ".vcetun",
        "+pecetun"
    ],
    "[N][Equ][2SgPoss][DuPosd]": [
        "%:(e)gpetun"
    ],
    "[N][Equ][2SgPoss][PlPosd]": [
        "–vtun",
        ".vtun",
        "+petun"
    ],
    "[N][Equ][2SgPoss][SgPosd]": [
        "–vtun",
        ".vtun",
        "+petun"
    ],
    "[N][Equ][3DuPoss][DuPosd]": [
        "%:(e)gkegtun"
    ],
    "[N][Equ][3DuPoss][PlPosd]": [
        "–kegtun"
    ],
    "[N][Equ][3DuPoss][SgPosd]": [
        ":(ng)agtun"
    ],
    "[N][Equ][3PlPoss][DuPosd]": [
        "%:(e)gkecetun"
    ],
    "[N][Equ][3PlPoss][PlPosd]": [
        ":(ng)icetun"
    ],
    "[N][Equ][3PlPoss][SgPosd]": [
        ":(ng)acetun"
    ],
    "[N][Equ][3SgPoss][DuPosd]": [
        "%:(e)gketun"
    ],
    "[N][Equ][3SgPoss][PlPosd]": [
        ":(ng)itun"
    ],
    "[N][Equ][3SgPoss][SgPosd]": [
        ":(ng)atun"
    ],
    "[N][Equ][4DuPoss][DuPosd]": [
        "%:(e)gmegtun"
    ],
    "[N][Equ][4DuPoss][PlPosd]": [
        "–megtun"
    ],
    "[N][Equ][4DuPoss][SgPosd]": [
        "–megtun"
    ],
    "[N][Equ][4PlPoss][DuPosd]": [
        "%:(e)gmegcetun"
    ],
    "[N][Equ][4PlPoss][PlPosd]": [
        "–megcetun"
    ],
    "[N][Equ][4PlPoss][SgPosd]": [
        "–megcetun"
    ],
    "[N][Equ][4SgPoss][DuPosd]": [
        "%:(e)gmitun"
    ],
    "[N][Equ][4SgPoss][PlPosd]": [
        "–mitun"
    ],
    "[N][Equ][4SgPoss][SgPosd]": [
        "–mitun"
    ],
    "[N][Equ][DuUnpd]": [
        "%:(e)gtun"
    ],
    "[N][Equ][PlUnpd]": [
        "%cetun"
    ],
    "[N][Equ][SgUnpd]": [
        "%tun"
    ],
    "[N][Loc][1DuPoss][DuPosd]": [
        "%:(e)gmegni"
    ],
    "[N][Loc][1DuPoss][PlPosd]": [
        "–megni"
    ],
    "[N][Loc][1DuPoss][SgPosd]": [
        "–megni"
    ],
    "[N][Loc][1PlPoss][DuPosd]": [
        "%:(e)gemten̄i"
    ],
    "[N][Loc][1PlPoss][PlPosd]": [
        "–mten̄i"
    ],
    "[N][Loc][1PlPoss][SgPosd]": [
        "–mten̄i"
    ],
    "[N][Loc][1SgPoss][DuPosd]": [
        "%:(e)gemni"
    ],
    "[N][Loc][1SgPoss][PlPosd]": [
        "–mni"
    ],
    "[N][Loc][1SgPoss][SgPosd]": [
        "–mni"
    ],
    "[N][Loc][2DuPoss][DuPosd]": [
        "%:(e)gpetegni"
    ],
    "[N][Loc][2DuPoss][PlPosd]": [
        "–vtegni",
        ".vtegni",
        "+petegni"
    ],
    "[N][Loc][2DuPoss][SgPosd]": [
        "–vtegni",
        ".vtegni",
        "+petegni"
    ],
    "[N][Loc][2PlPoss][DuPosd]": [
        "%:(e)gpecini",
        "%:(e)gpecen̄i"
    ],
    "[N][Loc][2PlPoss][PlPosd]": [
        "–vcini",
        "–vcen̄i",
        ".vcini",
        ".vcen̄i",
        "+pecini",
        "+pecen̄i"
    ],
    "[N][Loc][2PlPoss][SgPosd]": [
        "–vcini",
        "–vcen̄i",
        ".vcini",
        ".vcen̄i",
        "+pecini",
        "+pecen̄i"
    ],
    "[N][Loc][2SgPoss][DuPosd]": [
        "%:(e)gpeni"
    ],
    "[N][Loc][2SgPoss][PlPosd]": [
        "–vni",
        ".vni",
        "+peni"
    ],
    "[N][Loc][2SgPoss][SgPosd]": [
        "–vni",
        ".vni",
        "+peni"
    ],
    "[N][Loc][3DuPoss][DuPosd]": [
        "%:(e)gkegni"
    ],
    "[N][Loc][3DuPoss][PlPosd]": [
        "–kegni"
    ],
    "[N][Loc][3DuPoss][SgPosd]": [
        ":(ng)agni"
    ],
    "[N][Loc][3PlPoss][DuPosd]": [
        "%:(e)gketni"
    ],
    "[N][Loc][3PlPoss][PlPosd]": [
        ":(ng)itni"
    ],
    "[N][Loc][3PlPoss][SgPosd]": [
        ":(ng)atni"
    ],
    "[N][Loc][3SgPoss][DuPosd]": [
        "%:(e)gkeni"
    ],
    "[N][Loc][3SgPoss][PlPosd]": [
        ":(ng)ini"
    ],
    "[N][Loc][3SgPoss][SgPosd]": [
        ":(ng)ani"
    ],
    "[N][Loc][4DuPoss][DuPosd]": [
        "%:(e)gmegni"
    ],
    "[N][Loc][4DuPoss][PlPosd]": [
        "–megni"
    ],
    "[N][Loc][4DuPoss][SgPosd]": [
        "–megni"
    ],
    "[N][Loc][4PlPoss][DuPosd]": [
        "%:(e)gmeggni"
    ],
    "[N][Loc][4PlPoss][PlPosd]": [
        "–meggni"
    ],
    "[N][Loc][4PlPoss][SgPosd]": [
        "–meggni"
    ],
    "[N][Loc][4SgPoss][DuPosd]": [
        "%:(e)gmini"
    ],
    "[N][Loc][4SgPoss][PlPosd]": [
        "–mini"
    ],
    "[N][Loc][4SgPoss][SgPosd]": [
        "–mini"
    ],
    "[N][Loc][DuUnpd]": [
        "%:(e)gni"
    ],
    "[N][Loc][PlUnpd]": [
        "%~ni"
    ],
    "[N][Loc][SgUnpd]": [
        "%~mi"
    ],
    "[N][Rel][1DuPoss][DuPosd]": [
        "%:(e)gmegnuk"
    ],
    "[N][Rel][1DuPoss][PlPosd]": [
        "–megnuk",
        "–mnuk"
    ],
    "[N][Rel][1DuPoss][SgPosd]": [
        "–megnuk",
        "–mnuk"
    ],
    "[N][Rel][1PlPoss][DuPosd]": [
        "%:(e)gemta"
    ],
    "[N][Rel][1PlPoss][PlPosd]": [
        "–mta"
    ],
    "[N][Rel][1PlPoss][SgPosd]": [
        "–mta"
    ],
    "[N][Rel][1SgPoss][DuPosd]": [
        "%:(e)gma"
    ],
    "[N][Rel][1SgPoss][PlPosd]": [
        "–ma"
    ],
    "[N][Rel][1SgPoss][SgPosd]": [
        "–ma"
    ],
    "[N][Rel][2DuPoss][DuPosd]": [
        "%:(e)gpetek"
    ],
    "[N][Rel][2DuPoss][PlPosd]": [
        "–vtek",
        ".vtek",
        "+petek"
    ],
    "[N][Rel][2DuPoss][SgPosd]": [
        "–vtek",
        ".vtek",
        "+petek"
    ],
    "[N][Rel][2PlPoss][DuPosd]": [
        "%:(e)gpeci"
    ],
    "[N][Rel][2PlPoss][PlPosd]": [
        "–vci",
        ".vci",
        "+peci"
    ],
    "[N][Rel][2PlPoss][SgPosd]": [
        "–vci",
        ".vci",
        "+peci"
    ],
    "[N][Rel][2SgPoss][DuPosd]": [
        "%:(e)gpet"
    ],
    "[N][Rel][2SgPoss][PlPosd]": [
        "–vet",
        ".vet",
        "+pet"
    ],
    "[N][Rel][2SgPoss][SgPosd]": [
        "–vet",
        ".vet",
        "+pet"
    ],
    "[N][Rel][3DuPoss][DuPosd]": [
        "%:(e)gkenka"
    ],
    "[N][Rel][3DuPoss][PlPosd]": [
        "–kenka"
    ],
    "[N][Rel][3DuPoss][SgPosd]": [
        ":(ng)agnek"
    ],
    "[N][Rel][3PlPoss][DuPosd]": [
        "%:(e)gketa"
    ],
    "[N][Rel][3PlPoss][PlPosd]": [
        ":(ng)ita"
    ],
    "[N][Rel][3PlPoss][SgPosd]": [
        ":(ng)ata"
    ],
    "[N][Rel][3SgPoss][DuPosd]": [
        "%:(e)gken"
    ],
    "[N][Rel][3SgPoss][PlPosd]": [
        ":(ng)in"
    ],
    "[N][Rel][3SgPoss][SgPosd]": [
        ":(ng)an"
    ],
    "[N][Rel][4DuPoss][DuPosd]": [
        "%:(e)gmek"
    ],
    "[N][Rel][4DuPoss][PlPosd]": [
        "–mek"
    ],
    "[N][Rel][4DuPoss][SgPosd]": [
        "–mek"
    ],
    "[N][Rel][4PlPoss][DuPosd]": [
        "%:(e)gmeng"
    ],
    "[N][Rel][4PlPoss][PlPosd]": [
        "–megta",
        "–megteng",
        "–meng"
    ],
    "[N][Rel][4PlPoss][SgPosd]": [
        "–megta",
        "–megteng",
        "–meng"
    ],
    "[N][Rel][4SgPoss][DuPosd]": [
        "%:(e)gmi"
    ],
    "[N][Rel][4SgPoss][PlPosd]": [
        "–mi"
    ],
    "[N][Rel][4SgPoss][SgPosd]": [
        "–mi"
    ],
    "[N][Rel][DuUnpd]": [
        "%:(e)k"
    ],
    "[N][Rel][PlUnpd]": [
        "%:(e)t"
    ],
    "[N][Rel][SgUnpd]": [
        "%:(e)m"
    ],
    "[N][Ter][1DuPoss][DuPosd]": [
        "%:(e)gmegnun"
    ],
    "[N][Ter][1DuPoss][PlPosd]": [
        "–megnun"
    ],
    "[N][Ter][1DuPoss][SgPosd]": [
        "–megnun"
    ],
    "[N][Ter][1PlPoss][DuPosd]": [
        "%:(e)gemten̄un"
    ],
    "[N][Ter][1PlPoss][PlPosd]": [
        "–mten̄un"
    ],
    "[N][Ter][1PlPoss][SgPosd]": [
        "–mten̄un"
    ],
    "[N][Ter][1SgPoss][DuPosd]": [
        "%:(e)gemnun"
    ],
    "[N][Ter][1SgPoss][PlPosd]": [
        "–mnun"
    ],
    "[N][Ter][1SgPoss][SgPosd]": [
        "–mnun"
    ],
    "[N][Ter][2DuPoss][DuPosd]": [
        "%:(e)gpetegnun"
    ],
    "[N][Ter][2DuPoss][PlPosd]": [
        "–vtegnun",
        ".vtegnun",
        "+petegnun"
    ],
    "[N][Ter][2DuPoss][SgPosd]": [
        "–vtegnun",
        ".vtegnun",
        "+petegnun"
    ],
    "[N][Ter][2PlPoss][DuPosd]": [
        "%:(e)gpecinun",
        "%:(e)gpecen̄un"
    ],
    "[N][Ter][2PlPoss][PlPosd]": [
        "–vcinun",
        "–vcen̄un",
        ".vcinun",
        ".vcen̄un",
        "+pecinun",
        "+pecen̄un"
    ],
    "[N][Ter][2PlPoss][SgPosd]": [
        "–vcinun",
        "–vcen̄un",
        ".vcinun",
        ".vcen̄un",
        "+pecinun",
        "+pecen̄un"
    ],
    "[N][Ter][2SgPoss][DuPosd]": [
        "%:(e)gpenun"
    ],
    "[N][Ter][2SgPoss][PlPosd]": [
        "–vnun",
        ".vnun",
        "+penun"
    ],
    "[N][Ter][2SgPoss][SgPosd]": [
        "–vnun",
        ".vnun",
        "+penun"
    ],
    "[N][Ter][3DuPoss][DuPosd]": [
        "%:(e)gkegnun"
    ],
    "[N][Ter][3DuPoss][PlPosd]": [
        "–kegnun"
    ],
    "[N][Ter][3DuPoss][SgPosd]": [
        ":(ng)agnun"
    ],
    "[N][Ter][3PlPoss][DuPosd]": [
        "%:(e)gketnun"
    ],
    "[N][Ter][3PlPoss][PlPosd]": [
        ":(ng)itnun"
    ],
    "[N][Ter][3PlPoss][SgPosd]": [
        ":(ng)atnun"
    ],
    "[N][Ter][3SgPoss][DuPosd]": [
        "%:(e)gkenun"
    ],
    "[N][Ter][3SgPoss][PlPosd]": [
        ":(ng)inun"
    ],
    "[N][Ter][3SgPoss][SgPosd]": [
        ":(ng)anun"
    ],
    "[N][Ter][4DuPoss][DuPosd]": [
        "%:(e)gmegnun"
    ],
    "[N][Ter][4DuPoss][PlPosd]": [
        "–megnun"
    ],
    "[N][Ter][4DuPoss][SgPosd]": [
        "–megnun"
    ],
    "[N][Ter][4PlPoss][DuPosd]": [
        "%:(e)gmeggnun"
    ],
    "[N][Ter][4PlPoss][PlPosd]": [
        "–meggnun"
    ],
    "[N][Ter][4PlPoss][SgPosd]": [
        "–meggnun"
    ],
    "[N][Ter][4SgPoss][DuPosd]": [
        "%:(e)gminun"
    ],
    "[N][Ter][4SgPoss][PlPosd]": [
        "–minun"
    ],
    "[N][Ter][4SgPoss][SgPosd]": [
        "–minun"
    ],
    "[N][Ter][DuUnpd]": [
        "%:(e)gnun"
    ],
    "[N][Ter][PlUnpd]": [
        "%~nun"
    ],
    "[N][Ter][SgUnpd]": [
        "%~mun"
    ],
    "[N][Via][1DuPoss][DuPosd]": [
        "%:(e)gmegnegun"
    ],
    "[N][Via][1DuPoss][PlPosd]": [
        "–megnegun"
    ],
    "[N][Via][1DuPoss][SgPosd]": [
        "–megnegun"
    ],
    "[N][Via][1PlPoss][DuPosd]": [
        "%:(e)gemteggun"
    ],
    "[N][Via][1PlPoss][PlPosd]": [
        "–mteggun"
    ],
    "[N][Via][1PlPoss][SgPosd]": [
        "–mteggun"
    ],
    "[N][Via][1SgPoss][DuPosd]": [
        "%:(e)gemkun"
    ],
    "[N][Via][1SgPoss][PlPosd]": [
        "–mkun"
    ],
    "[N][Via][1SgPoss][SgPosd]": [
        "–mkun"
    ],
    "[N][Via][2DuPoss][DuPosd]": [
        "%:(e)gpetegnegun"
    ],
    "[N][Via][2DuPoss][PlPosd]": [
        "–vtegnegun",
        ".vtegnegun",
        "+petegnegun"
    ],
    "[N][Via][2DuPoss][SgPosd]": [
        "–vtegnegun",
        ".vtegnegun",
        "+petegnegun"
    ],
    "[N][Via][2PlPoss][DuPosd]": [
        "%:(e)gpeciuggun",
        "%:(e)gpecetgun"
    ],
    "[N][Via][2PlPoss][PlPosd]": [
        "–vciuggun",
        "–vcetgun",
        ".vciuggun",
        ".vcetgun",
        "+peciuggun",
        "+pecetgun"
    ],
    "[N][Via][2PlPoss][SgPosd]": [
        "–vciuggun",
        "–vcetgun",
        ".vciuggun",
        ".vcetgun",
        "+peciuggun",
        "+pecetgun"
    ],
    "[N][Via][2SgPoss][DuPosd]": [
        "%:(e)gpegun"
    ],
    "[N][Via][2SgPoss][PlPosd]": [
        "–vkun",
        "+pegun",
        ".vkun"
    ],
    "[N][Via][2SgPoss][SgPosd]": [
        "–vkun",
        "+pegun",
        ".vkun"
    ],
    "[N][Via][3DuPoss][DuPosd]": [
        "%:(e)gkegnegun"
    ],
    "[N][Via][3DuPoss][PlPosd]": [
        "–kegnegun"
    ],
    "[N][Via][3DuPoss][SgPosd]": [
        ":(ng)agnegun"
    ],
    "[N][Via][3PlPoss][DuPosd]": [
        "%:(e)gketgun"
    ],
    "[N][Via][3PlPoss][PlPosd]": [
        ":(ng)itgun"
    ],
    "[N][Via][3PlPoss][SgPosd]": [
        ":(ng)atgun"
    ],
    "[N][Via][3SgPoss][DuPosd]": [
        "%:(e)gkenkun"
    ],
    "[N][Via][3SgPoss][PlPosd]": [
        ":(ng)ikun"
    ],
    "[N][Via][3SgPoss][SgPosd]": [
        ":(ng)akun"
    ],
    "[N][Via][4DuPoss][DuPosd]": [
        "%:(e)gmegnegun"
    ],
    "[N][Via][4DuPoss][PlPosd]": [
        "–megnegun"
    ],
    "[N][Via][4DuPoss][SgPosd]": [
        "–megnegun"
    ],
    "[N][Via][4PlPoss][DuPosd]": [
        "%:(e)gmegteggun"
    ],
    "[N][Via][4PlPoss][PlPosd]": [
        "–megteggun"
    ],
    "[N][Via][4PlPoss][SgPosd]": [
        "–megteggun"
    ],
    "[N][Via][4SgPoss][DuPosd]": [
        "%:(e)gmikun"
    ],
    "[N][Via][4SgPoss][PlPosd]": [
        "–mikun"
    ],
    "[N][Via][4SgPoss][SgPosd]": [
        "–mikun"
    ],
    "[N][Via][DuUnpd]": [
        "%:(e)gkun",
        "%:(e)gnegun"
    ],
    "[N][Via][PlUnpd]": [
        "%tgun"
    ],
    "[N][Via][SgUnpd]": [
        "%kun"
    ],
    "[Quant_Qual][A_1Du]": [
        "–megnuk"
    ],
    "[Quant_Qual][A_1Pl]": [
        "–mta"
    ],
    "[Quant_Qual][A_1Sg]": [
        "+ma"
    ],
    "[Quant_Qual][A_2Du]": [
        ".vtek",
        "+petek"
    ],
    "[Quant_Qual][A_2Pl]": [
        ".vci",
        "+peci"
    ],
    "[Quant_Qual][A_2Sg]": [
        ".vet",
        "+pet"
    ],
    "[Quant_Qual][A_4Du]": [
        "+mek"
    ],
    "[Quant_Qual][A_4Pl]": [
        "+meng"
    ],
    "[Quant_Qual][A_4Sg]": [
        "+mi"
    ],
    "[Quant_Qual][P_1Du]": [
        "–megnuk"
    ],
    "[Quant_Qual][P_1Pl]": [
        "–mta"
    ],
    "[Quant_Qual][P_1Sg]": [
        "+ma"
    ],
    "[Quant_Qual][P_2Du]": [
        ".vtek",
        "+petek"
    ],
    "[Quant_Qual][P_2Pl]": [
        ".vci",
        "+peci"
    ],
    "[Quant_Qual][P_2Sg]": [
        ".vet",
        "+pet"
    ],
    "[Quant_Qual][P_3Du]": [
        "%:(e)gkenka"
    ],
    "[Quant_Qual][P_3Pl]": [
        ":(ng)ita"
    ],
    "[Quant_Qual][P_3Sg]": [
        ":(ng)an"
    ],
    "[Quant_Qual][S_1Du]": [
        "–megnuk"
    ],
    "[Quant_Qual][S_1Pl]": [
        "–mta"
    ],
    "[Quant_Qual][S_1Sg]": [
        "+ma"
    ],
    "[Quant_Qual][S_2Du]": [
        ".vtek",
        "+petek"
    ],
    "[Quant_Qual][S_2Pl]": [
        ".vci",
        "+peci"
    ],
    "[Quant_Qual][S_2Sg]": [
        ".vet",
        "+pet"
    ],
    "[Quant_Qual][S_4Du]": [
        "+mek"
    ],
    "[Quant_Qual][S_4Pl]": [
        "+meng"
    ],
    "[Quant_Qual][S_4Sg]": [
        "+mi"
    ],
    "[Rel][DuUnpd]": [
        ".k"
    ],
    "[Rel][PlUnpd]": [
        ".t"
    ],
    "[Rel][SgUnpd]": [
        ".m"
    ],
    "[Sec_Ter]": [
        ".tmun"
    ],
    "[Ter]": [
        ".vet"
    ],
    "[Ter][DuUnpd]": [
        ".gnun"
    ],
    "[Ter][PlUnpd]": [
        ".nun"
    ],
    "[Ter][SgUnpd]": [
        ".mun"
    ],
    "[V][Cnsq][Intr][S_1Du]": [
        "@%:~(ng)a–megnuk",
        "@~+nga–megnuk"
    ],
    "[V][Cnsq][Intr][S_1Pl]": [
        "@%:~(ng)a–mta",
        "@~+nga–mta"
    ],
    "[V][Cnsq][Intr][S_1Sg]": [
        "@%:~(ng)a+ma",
        "@~+nga+ma"
    ],
    "[V][Cnsq][Intr][S_2Du]": [
        "@%:~(ng)a.vtek",
        "@~+nga.vtek"
    ],
    "[V][Cnsq][Intr][S_2Pl]": [
        "@%:~(ng)a.veci",
        "@~+nga.veci"
    ],
    "[V][Cnsq][Intr][S_2Sg]": [
        "@%:~(ng)a.vet",
        "@~+nga.vet"
    ],
    "[V][Cnsq][Intr][S_3Du]": [
        "@%:~(ng)a:agnek",
        "@~+nga:agnek"
    ],
    "[V][Cnsq][Intr][S_3Pl]": [
        "@%:~(ng)a:ata",
        "@~+nga:ata"
    ],
    "[V][Cnsq][Intr][S_3Sg]": [
        "@%:~(ng)a:an",
        "@~+nga:an"
    ],
    "[V][Cnsq][Intr][S_4Du]": [
        "@%:~(ng)a+mek",
        "@~+nga+mek"
    ],
    "[V][Cnsq][Intr][S_4Pl]": [
        "@%:~(ng)a+meng",
        "@~+nga+meng"
    ],
    "[V][Cnsq][Intr][S_4Sg]": [
        "@%:~(ng)a+mi",
        "@~+nga+mi"
    ],
    "[V][Cnsq][Trns][A_1Du][P_2Du]": [
        "@%:~(ng)a–megtek",
        "@~+nga–megtek"
    ],
    "[V][Cnsq][Trns][A_1Du][P_2Pl]": [
        "@%:~(ng)a–megci",
        "@~+nga–megci"
    ],
    "[V][Cnsq][Trns][A_1Du][P_2Sg]": [
        "@%:~(ng)a–megten",
        "@~+nga–megten"
    ],
    "[V][Cnsq][Trns][A_1Du][P_3Du]": [
        "@%:~(ng)a–megkek",
        "@~+nga–megkek"
    ],
    "[V][Cnsq][Trns][A_1Du][P_3Pl]": [
        "@%:~(ng)a–megki",
        "@~+nga–megki"
    ],
    "[V][Cnsq][Trns][A_1Du][P_3Sg]": [
        "@%:~(ng)a–megnegu",
        "@~+nga–megnegu"
    ],
    "[V][Cnsq][Trns][A_1Du][P_4Du]": [
        "@%:~(ng)a–megtek",
        "@~+nga–megtek"
    ],
    "[V][Cnsq][Trns][A_1Du][P_4Pl]": [
        "@%:~(ng)a–megteng",
        "@~+nga–megteng"
    ],
    "[V][Cnsq][Trns][A_1Du][P_4Sg]": [
        "@%:~(ng)a–megni",
        "@~+nga–megni"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_2Du]": [
        "@%:~(ng)a–mcetek",
        "@~+nga–mcetek"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_2Pl]": [
        "@%:~(ng)a–mceci",
        "@~+nga–mceci"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_2Sg]": [
        "@%:~(ng)a–mteggen",
        "@~+nga–mteggen"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_3Du]": [
        "@%:~(ng)a–mtekek",
        "@~+nga–mtekek"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_3Pl]": [
        "@%:~(ng)a–mteki",
        "@~+nga–mteki"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_3Sg]": [
        "@%:~(ng)a–mteggu",
        "@~+nga–mteggu"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_4Du]": [
        "@%:~(ng)a–mcetek",
        "@~+nga–mcetek"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_4Pl]": [
        "@%:~(ng)a–mceteng",
        "@~+nga–mceteng"
    ],
    "[V][Cnsq][Trns][A_1Pl][P_4Sg]": [
        "@%:~(ng)a–mten̄i",
        "@~+nga–mten̄i"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_2Du]": [
        "@%:~(ng)a–mtek",
        "@~+nga–mtek"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_2Pl]": [
        "@%:~(ng)a–mci",
        "@~+nga–mci"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_2Sg]": [
        "@%:~(ng)a–mken",
        "@~+nga–mken"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_3Du]": [
        "@%:~(ng)a–mkek",
        "@~+nga–mkek"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_3Pl]": [
        "@%:~(ng)a–mki",
        "@~+nga–mki"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_3Sg]": [
        "@%:~(ng)a–mku",
        "@~+nga–mku"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_4Du]": [
        "@%:~(ng)a–mtek",
        "@~+nga–mtek"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_4Pl]": [
        "@%:~(ng)a–mteng",
        "@~+nga–mteng"
    ],
    "[V][Cnsq][Trns][A_1Sg][P_4Sg]": [
        "@%:~(ng)a–mni",
        "@~+nga–mni"
    ],
    "[V][Cnsq][Trns][A_2Du][P_1Du]": [
        "@%:~(ng)a.vtegkuk",
        "@~+nga.vtegkuk"
    ],
    "[V][Cnsq][Trns][A_2Du][P_1Pl]": [
        "@%:~(ng)a.vtegkut",
        "@~+nga.vtegkut"
    ],
    "[V][Cnsq][Trns][A_2Du][P_1Sg]": [
        "@%:~(ng)a.vtegnga",
        "@~+nga.vtegnga"
    ],
    "[V][Cnsq][Trns][A_2Du][P_3Du]": [
        "@%:~(ng)a.vtegkek",
        "@~+nga.vtegkek"
    ],
    "[V][Cnsq][Trns][A_2Du][P_3Pl]": [
        "@%:~(ng)a.vtegki",
        "@~+nga.vtegki"
    ],
    "[V][Cnsq][Trns][A_2Du][P_3Sg]": [
        "@%:~(ng)a.vtegnegu",
        "@~+nga.vtegnegu"
    ],
    "[V][Cnsq][Trns][A_2Du][P_4Du]": [
        "@%:~(ng)a.vtegtek",
        "@~+nga.vtegtek"
    ],
    "[V][Cnsq][Trns][A_2Du][P_4Pl]": [
        "@%:~(ng)a.vtegteng",
        "@~+nga.vtegteng"
    ],
    "[V][Cnsq][Trns][A_2Du][P_4Sg]": [
        "@%:~(ng)a.vtegni",
        "@~+nga.vtegni"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_1Du]": [
        "@%:~(ng)a.vcikuk",
        "@~+nga.vcikuk"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_1Pl]": [
        "@%:~(ng)a.vcikut",
        "@~+nga.vcikut"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_1Sg]": [
        "@%:~(ng)a.vcia",
        "@~+nga.vcia"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_3Du]": [
        "@%:~(ng)a.vcikek",
        "@~+nga.vcikek"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_3Pl]": [
        "@%:~(ng)a.vciki",
        "@~+nga.vciki"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_3Sg]": [
        "@%:~(ng)a.vciu",
        "@~+nga.vciu"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_4Du]": [
        "@%:~(ng)a.vcitek",
        "@~+nga.vcitek"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_4Pl]": [
        "@%:~(ng)a.vciteng",
        "@~+nga.vciteng"
    ],
    "[V][Cnsq][Trns][A_2Pl][P_4Sg]": [
        "@%:~(ng)a.vcini",
        "@~+nga.vcini"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_1Du]": [
        "@%:~(ng)a.vkuk",
        "@~+nga.vkuk"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_1Pl]": [
        "@%:~(ng)a.vkut",
        "@~+nga.vkut"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_1Sg]": [
        "@%:~(ng)a.vnga",
        "@~+nga.vnga"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_3Du]": [
        "@%:~(ng)a.vkek",
        "@~+nga.vkek"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_3Pl]": [
        "@%:~(ng)a.vki",
        "@~+nga.vki"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_3Sg]": [
        "@%:~(ng)a.vgu",
        "@~+nga.vgu"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_4Du]": [
        "@%:~(ng)a.vtek",
        "@~+nga.vtek"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_4Pl]": [
        "@%:~(ng)a.vteng",
        "@~+nga.vteng"
    ],
    "[V][Cnsq][Trns][A_2Sg][P_4Sg]": [
        "@%:~(ng)a.vni",
        "@~+nga.vni"
    ],
    "[V][Cnsq][Trns][A_3Du][P_1Du]": [
        "@%:~(ng)a:agkuk",
        "@~+nga:agkuk"
    ],
    "[V][Cnsq][Trns][A_3Du][P_1Pl]": [
        "@%:~(ng)a:agkut",
        "@~+nga:agkut"
    ],
    "[V][Cnsq][Trns][A_3Du][P_1Sg]": [
        "@%:~(ng)a:agnga",
        "@~+nga:agnga"
    ],
    "[V][Cnsq][Trns][A_3Du][P_2Du]": [
        "@%:~(ng)a:agtek",
        "@~+nga:agtek"
    ],
    "[V][Cnsq][Trns][A_3Du][P_2Pl]": [
        "@%:~(ng)a:agci",
        "@~+nga:agci"
    ],
    "[V][Cnsq][Trns][A_3Du][P_2Sg]": [
        "@%:~(ng)a:agten",
        "@~+nga:agten"
    ],
    "[V][Cnsq][Trns][A_3Du][P_3Du]": [
        "@%:~(ng)a:agkek",
        "@~+nga:agkek"
    ],
    "[V][Cnsq][Trns][A_3Du][P_3Pl]": [
        "@%:~(ng)a:agki",
        "@~+nga:agki"
    ],
    "[V][Cnsq][Trns][A_3Du][P_3Sg]": [
        "@%:~(ng)a:agnegu",
        "@~+nga:agnegu"
    ],
    "[V][Cnsq][Trns][A_3Du][P_4Du]": [
        "@%:~(ng)a:agtek",
        "@~+nga:agtek"
    ],
    "[V][Cnsq][Trns][A_3Du][P_4Pl]": [
        "@%:~(ng)a:agteng",
        "@~+nga:agteng"
    ],
    "[V][Cnsq][Trns][A_3Du][P_4Sg]": [
        "@%:~(ng)a:agni",
        "@~+nga:agni"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_1Du]": [
        "@%:~(ng)a:atkuk",
        "@~+nga:atkuk"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_1Pl]": [
        "@%:~(ng)a:atkut",
        "@~+nga:atkut"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_1Sg]": [
        "@%:~(ng)a:atnga",
        "@~+nga:atnga"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_2Du]": [
        "@%:~(ng)a:acetek",
        "@~+nga:acetek"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_2Pl]": [
        "@%:~(ng)a:aceci",
        "@~+nga:aceci"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_2Sg]": [
        "@%:~(ng)a:atgen",
        "@~+nga:atgen"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_3Du]": [
        "@%:~(ng)a:atkek",
        "@~+nga:atkek"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_3Pl]": [
        "@%:~(ng)a:atki",
        "@~+nga:atki"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_3Sg]": [
        "@%:~(ng)a:atgu",
        "@~+nga:atgu"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_4Du]": [
        "@%:~(ng)a:acetek",
        "@~+nga:acetek"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_4Pl]": [
        "@%:~(ng)a:aceteng",
        "@~+nga:aceteng"
    ],
    "[V][Cnsq][Trns][A_3Pl][P_4Sg]": [
        "@%:~(ng)a:atni",
        "@~+nga:atni"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_1Du]": [
        "@%:~(ng)a:akuk",
        "@~+nga:akuk"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_1Pl]": [
        "@%:~(ng)a:akut",
        "@~+nga:akut"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_1Sg]": [
        "@%:~(ng)a:anga",
        "@~+nga:anga"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_2Du]": [
        "@%:~(ng)a:atek",
        "@~+nga:atek"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_2Pl]": [
        "@%:~(ng)a:aci",
        "@~+nga:aci"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_2Sg]": [
        "@%:~(ng)a:aten",
        "@~+nga:aten"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_3Du]": [
        "@%:~(ng)a:akek",
        "@~+nga:akek"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_3Pl]": [
        "@%:~(ng)a:aki",
        "@~+nga:aki"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_3Sg]": [
        "@%:~(ng)a:aku",
        "@~+nga:aku"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_4Du]": [
        "@%:~(ng)a:atek",
        "@~+nga:atek"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_4Pl]": [
        "@%:~(ng)a:ateng",
        "@~+nga:ateng"
    ],
    "[V][Cnsq][Trns][A_3Sg][P_4Sg]": [
        "@%:~(ng)a:ani",
        "@~+nga:ani"
    ],
    "[V][Cnsq][Trns][A_4Du][P_1Du]": [
        "@%:~(ng)a+megnekuk",
        "@~+nga+megnekuk"
    ],
    "[V][Cnsq][Trns][A_4Du][P_1Pl]": [
        "@%:~(ng)a+megnekut",
        "@~+nga+megnekut"
    ],
    "[V][Cnsq][Trns][A_4Du][P_1Sg]": [
        "@%:~(ng)a+megnenga",
        "@~+nga+megnenga"
    ],
    "[V][Cnsq][Trns][A_4Du][P_2Du]": [
        "@%:~(ng)a+megnetek",
        "@~+nga+megnetek"
    ],
    "[V][Cnsq][Trns][A_4Du][P_2Pl]": [
        "@%:~(ng)a+megneci",
        "@~+nga+megneci"
    ],
    "[V][Cnsq][Trns][A_4Du][P_2Sg]": [
        "@%:~(ng)a+megnegen",
        "@~+nga+megnegen"
    ],
    "[V][Cnsq][Trns][A_4Du][P_3Du]": [
        "@%:~(ng)a+megnekek",
        "@~+nga+megnekek"
    ],
    "[V][Cnsq][Trns][A_4Du][P_3Pl]": [
        "@%:~(ng)a+megneki",
        "@~+nga+megneki"
    ],
    "[V][Cnsq][Trns][A_4Du][P_3Sg]": [
        "@%:~(ng)a+megnegu",
        "@~+nga+megnegu"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_1Du]": [
        "@%:~(ng)a+megtekuk",
        "@~+nga+megtekuk"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_1Pl]": [
        "@%:~(ng)a+megtekut",
        "@~+nga+megtekut"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_1Sg]": [
        "@%:~(ng)a+megtenga",
        "@~+nga+megtenga"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_2Du]": [
        "@%:~(ng)a+megcetek",
        "@~+nga+megcetek"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_2Pl]": [
        "@%:~(ng)a+megceci",
        "@~+nga+megceci"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_2Sg]": [
        "@%:~(ng)a+megteggen",
        "@~+nga+megteggen"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_3Du]": [
        "@%:~(ng)a+megtekek",
        "@~+nga+megtekek"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_3Pl]": [
        "@%:~(ng)a+megteki",
        "@~+nga+megteki"
    ],
    "[V][Cnsq][Trns][A_4Pl][P_3Sg]": [
        "@%:~(ng)a+megteggu",
        "@~+nga+megteggu"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_1Du]": [
        "@%:~(ng)a+mikuk",
        "@~+nga+mikuk"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_1Pl]": [
        "@%:~(ng)a+mikut",
        "@~+nga+mikut"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_1Sg]": [
        "@%:~(ng)a+mia",
        "@~+nga+mia"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_2Du]": [
        "@%:~(ng)a+mitek",
        "@~+nga+mitek"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_2Pl]": [
        "@%:~(ng)a+mici",
        "@~+nga+mici"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_2Sg]": [
        "@%:~(ng)a+miten",
        "@~+nga+miten"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_3Du]": [
        "@%:~(ng)a+mikek",
        "@~+nga+mikek"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_3Pl]": [
        "@%:~(ng)a+miki",
        "@~+nga+miki"
    ],
    "[V][Cnsq][Trns][A_4Sg][P_3Sg]": [
        "@%:~(ng)a+miu",
        "@~+nga+miu"
    ],
    "[V][Conc][Intr][S_1Du]": [
        "@–ngrar–megnuk"
    ],
    "[V][Conc][Intr][S_1Pl]": [
        "@–ngrar–mta"
    ],
    "[V][Conc][Intr][S_1Sg]": [
        "@–nger+ma"
    ],
    "[V][Conc][Intr][S_2Du]": [
        "@–nger+petek"
    ],
    "[V][Conc][Intr][S_2Pl]": [
        "@–nger+peci"
    ],
    "[V][Conc][Intr][S_2Sg]": [
        "@–nger+pet"
    ],
    "[V][Conc][Intr][S_3Du]": [
        "@–ngrar:agnek"
    ],
    "[V][Conc][Intr][S_3Pl]": [
        "@–ngrar:ata"
    ],
    "[V][Conc][Intr][S_3Sg]": [
        "@–ngrar:an"
    ],
    "[V][Conc][Intr][S_4Du]": [
        "@–nger+mek"
    ],
    "[V][Conc][Intr][S_4Pl]": [
        "@–nger+meng"
    ],
    "[V][Conc][Intr][S_4Sg]": [
        "@–nger+mi"
    ],
    "[V][Conc][Trns][A_1Du][P_2Du]": [
        "@–ngrar–megtek"
    ],
    "[V][Conc][Trns][A_1Du][P_2Pl]": [
        "@–ngrar–megci"
    ],
    "[V][Conc][Trns][A_1Du][P_2Sg]": [
        "@–ngrar–megten"
    ],
    "[V][Conc][Trns][A_1Du][P_3Du]": [
        "@–ngrar–megkek"
    ],
    "[V][Conc][Trns][A_1Du][P_3Pl]": [
        "@–ngrar–megki"
    ],
    "[V][Conc][Trns][A_1Du][P_3Sg]": [
        "@–ngrar–megnegu"
    ],
    "[V][Conc][Trns][A_1Du][P_4Du]": [
        "@–ngrar–megtek"
    ],
    "[V][Conc][Trns][A_1Du][P_4Pl]": [
        "@–ngrar–megteng"
    ],
    "[V][Conc][Trns][A_1Du][P_4Sg]": [
        "@–ngrar–megni"
    ],
    "[V][Conc][Trns][A_1Pl][P_2Du]": [
        "@–ngrar–mcetek"
    ],
    "[V][Conc][Trns][A_1Pl][P_2Pl]": [
        "@–ngrar–mceci"
    ],
    "[V][Conc][Trns][A_1Pl][P_2Sg]": [
        "@–ngrar–mteggen"
    ],
    "[V][Conc][Trns][A_1Pl][P_3Du]": [
        "@–ngrar–mtekek"
    ],
    "[V][Conc][Trns][A_1Pl][P_3Pl]": [
        "@–ngrar–mteki"
    ],
    "[V][Conc][Trns][A_1Pl][P_3Sg]": [
        "@–ngrar–mteggu"
    ],
    "[V][Conc][Trns][A_1Pl][P_4Du]": [
        "@–ngrar–mcetek"
    ],
    "[V][Conc][Trns][A_1Pl][P_4Pl]": [
        "@–ngrar–mceteng"
    ],
    "[V][Conc][Trns][A_1Pl][P_4Sg]": [
        "@–ngrar–mten̄i"
    ],
    "[V][Conc][Trns][A_1Sg][P_2Du]": [
        "@–ngrar–mtek"
    ],
    "[V][Conc][Trns][A_1Sg][P_2Pl]": [
        "@–ngrar–mci"
    ],
    "[V][Conc][Trns][A_1Sg][P_2Sg]": [
        "@–ngrar–mken"
    ],
    "[V][Conc][Trns][A_1Sg][P_3Du]": [
        "@–ngrar–mkek"
    ],
    "[V][Conc][Trns][A_1Sg][P_3Pl]": [
        "@–ngrar–mki"
    ],
    "[V][Conc][Trns][A_1Sg][P_3Sg]": [
        "@–ngrar–mku"
    ],
    "[V][Conc][Trns][A_1Sg][P_4Du]": [
        "@–ngrar–mtek"
    ],
    "[V][Conc][Trns][A_1Sg][P_4Pl]": [
        "@–ngrar–mteng"
    ],
    "[V][Conc][Trns][A_1Sg][P_4Sg]": [
        "@–ngrar–mni"
    ],
    "[V][Conc][Trns][A_2Du][P_1Du]": [
        "@–nger+petegkuk"
    ],
    "[V][Conc][Trns][A_2Du][P_1Pl]": [
        "@–nger+petegkut"
    ],
    "[V][Conc][Trns][A_2Du][P_1Sg]": [
        "@–nger+petegnga"
    ],
    "[V][Conc][Trns][A_2Du][P_3Du]": [
        "@–nger+petegkek"
    ],
    "[V][Conc][Trns][A_2Du][P_3Pl]": [
        "@–nger+petegki"
    ],
    "[V][Conc][Trns][A_2Du][P_3Sg]": [
        "@–nger+petegnegu"
    ],
    "[V][Conc][Trns][A_2Du][P_4Du]": [
        "@–nger+petegtek"
    ],
    "[V][Conc][Trns][A_2Du][P_4Pl]": [
        "@–nger+petegteng"
    ],
    "[V][Conc][Trns][A_2Du][P_4Sg]": [
        "@–nger+petegni"
    ],
    "[V][Conc][Trns][A_2Pl][P_1Du]": [
        "@–nger+pecikuk"
    ],
    "[V][Conc][Trns][A_2Pl][P_1Pl]": [
        "@–nger+pecikut"
    ],
    "[V][Conc][Trns][A_2Pl][P_1Sg]": [
        "@–nger+pecia"
    ],
    "[V][Conc][Trns][A_2Pl][P_3Du]": [
        "@–nger+pecikek"
    ],
    "[V][Conc][Trns][A_2Pl][P_3Pl]": [
        "@–nger+peciki"
    ],
    "[V][Conc][Trns][A_2Pl][P_3Sg]": [
        "@–nger+peciu"
    ],
    "[V][Conc][Trns][A_2Pl][P_4Du]": [
        "@–nger+pecitek"
    ],
    "[V][Conc][Trns][A_2Pl][P_4Pl]": [
        "@–nger+peciteng"
    ],
    "[V][Conc][Trns][A_2Pl][P_4Sg]": [
        "@–nger+pecini"
    ],
    "[V][Conc][Trns][A_2Sg][P_1Du]": [
        "@–nger+pekuk"
    ],
    "[V][Conc][Trns][A_2Sg][P_1Pl]": [
        "@–nger+pekut"
    ],
    "[V][Conc][Trns][A_2Sg][P_1Sg]": [
        "@–nger+penga"
    ],
    "[V][Conc][Trns][A_2Sg][P_3Du]": [
        "@–nger+pekek"
    ],
    "[V][Conc][Trns][A_2Sg][P_3Pl]": [
        "@–nger+peki"
    ],
    "[V][Conc][Trns][A_2Sg][P_3Sg]": [
        "@–nger+pegu"
    ],
    "[V][Conc][Trns][A_2Sg][P_4Du]": [
        "@–nger+petek"
    ],
    "[V][Conc][Trns][A_2Sg][P_4Pl]": [
        "@–nger+peteng"
    ],
    "[V][Conc][Trns][A_2Sg][P_4Sg]": [
        "@–nger+peni"
    ],
    "[V][Conc][Trns][A_3Du][P_1Du]": [
        "@–ngrar:agkuk"
    ],
    "[V][Conc][Trns][A_3Du][P_1Pl]": [
        "@–ngrar:agkut"
    ],
    "[V][Conc][Trns][A_3Du][P_1Sg]": [
        "@–ngrar:agnga"
    ],
    "[V][Conc][Trns][A_3Du][P_2Du]": [
        "@–ngrar:agtek"
    ],
    "[V][Conc][Trns][A_3Du][P_2Pl]": [
        "@–ngrar:agci"
    ],
    "[V][Conc][Trns][A_3Du][P_2Sg]": [
        "@–ngrar:agten"
    ],
    "[V][Conc][Trns][A_3Du][P_3Du]": [
        "@–ngrar:agkek"
    ],
    "[V][Conc][Trns][A_3Du][P_3Pl]": [
        "@–ngrar:agki"
    ],
    "[V][Conc][Trns][A_3Du][P_3Sg]": [
        "@–ngrar:agnegu"
    ],
    "[V][Conc][Trns][A_3Du][P_4Du]": [
        "@–ngrar:agtek"
    ],
    "[V][Conc][Trns][A_3Du][P_4Pl]": [
        "@–ngrar:agteng"
    ],
    "[V][Conc][Trns][A_3Du][P_4Sg]": [
        "@–ngrar:agni"
    ],
    "[V][Conc][Trns][A_3Pl][P_1Du]": [
        "@–ngrar:atkuk"
    ],
    "[V][Conc][Trns][A_3Pl][P_1Pl]": [
        "@–ngrar:atkut"
    ],
    "[V][Conc][Trns][A_3Pl][P_1Sg]": [
        "@–ngrar:atnga"
    ],
    "[V][Conc][Trns][A_3Pl][P_2Du]": [
        "@–ngrar:acetek"
    ],
    "[V][Conc][Trns][A_3Pl][P_2Pl]": [
        "@–ngrar:aceci"
    ],
    "[V][Conc][Trns][A_3Pl][P_2Sg]": [
        "@–ngrar:atgen"
    ],
    "[V][Conc][Trns][A_3Pl][P_3Du]": [
        "@–ngrar:atkek"
    ],
    "[V][Conc][Trns][A_3Pl][P_3Pl]": [
        "@–ngrar:atki"
    ],
    "[V][Conc][Trns][A_3Pl][P_3Sg]": [
        "@–ngrar:atgu"
    ],
    "[V][Conc][Trns][A_3Pl][P_4Du]": [
        "@–ngrar:acetek"
    ],
    "[V][Conc][Trns][A_3Pl][P_4Pl]": [
        "@–ngrar:aceteng"
    ],
    "[V][Conc][Trns][A_3Pl][P_4Sg]": [
        "@–ngrar:atni"
    ],
    "[V][Conc][Trns][A_3Sg][P_1Du]": [
        "@–ngrar:akuk"
    ],
    "[V][Conc][Trns][A_3Sg][P_1Pl]": [
        "@–ngrar:akut"
    ],
    "[V][Conc][Trns][A_3Sg][P_1Sg]": [
        "@–ngrar:anga"
    ],
    "[V][Conc][Trns][A_3Sg][P_2Du]": [
        "@–ngrar:atek"
    ],
    "[V][Conc][Trns][A_3Sg][P_2Pl]": [
        "@–ngrar:aci"
    ],
    "[V][Conc][Trns][A_3Sg][P_2Sg]": [
        "@–ngrar:aten"
    ],
    "[V][Conc][Trns][A_3Sg][P_3Du]": [
        "@–ngrar:akek"
    ],
    "[V][Conc][Trns][A_3Sg][P_3Pl]": [
        "@–ngrar:aki"
    ],
    "[V][Conc][Trns][A_3Sg][P_3Sg]": [
        "@–ngrar:aku"
    ],
    "[V][Conc][Trns][A_3Sg][P_4Du]": [
        "@–ngrar:atek"
    ],
    "[V][Conc][Trns][A_3Sg][P_4Pl]": [
        "@–ngrar:ateng"
    ],
    "[V][Conc][Trns][A_3Sg][P_4Sg]": [
        "@–ngrar:ani"
    ],
    "[V][Conc][Trns][A_4Du][P_1Du]": [
        "@–nger+megnekuk"
    ],
    "[V][Conc][Trns][A_4Du][P_1Pl]": [
        "@–nger+megnekut"
    ],
    "[V][Conc][Trns][A_4Du][P_1Sg]": [
        "@–nger+megnenga"
    ],
    "[V][Conc][Trns][A_4Du][P_2Du]": [
        "@–nger+megnetek"
    ],
    "[V][Conc][Trns][A_4Du][P_2Pl]": [
        "@–nger+megneci"
    ],
    "[V][Conc][Trns][A_4Du][P_2Sg]": [
        "@–nger+megnegen"
    ],
    "[V][Conc][Trns][A_4Du][P_3Du]": [
        "@–nger+megnekek"
    ],
    "[V][Conc][Trns][A_4Du][P_3Pl]": [
        "@–nger+megneki"
    ],
    "[V][Conc][Trns][A_4Du][P_3Sg]": [
        "@–nger+megnegu"
    ],
    "[V][Conc][Trns][A_4Pl][P_1Du]": [
        "@–nger+megtekuk"
    ],
    "[V][Conc][Trns][A_4Pl][P_1Pl]": [
        "@–nger+megtekut"
    ],
    "[V][Conc][Trns][A_4Pl][P_1Sg]": [
        "@–nger+megtenga"
    ],
    "[V][Conc][Trns][A_4Pl][P_2Du]": [
        "@–nger+megcetek"
    ],
    "[V][Conc][Trns][A_4Pl][P_2Pl]": [
        "@–nger+megceci"
    ],
    "[V][Conc][Trns][A_4Pl][P_2Sg]": [
        "@–nger+megteggen"
    ],
    "[V][Conc][Trns][A_4Pl][P_3Du]": [
        "@–nger+megtekek"
    ],
    "[V][Conc][Trns][A_4Pl][P_3Pl]": [
        "@–nger+megteki"
    ],
    "[V][Conc][Trns][A_4Pl][P_3Sg]": [
        "@–nger+megteggu"
    ],
    "[V][Conc][Trns][A_4Sg][P_1Du]": [
        "@–nger+mikuk"
    ],
    "[V][Conc][Trns][A_4Sg][P_1Pl]": [
        "@–nger+mikut"
    ],
    "[V][Conc][Trns][A_4Sg][P_1Sg]": [
        "@–nger+mia"
    ],
    "[V][Conc][Trns][A_4Sg][P_2Du]": [
        "@–nger+mitek"
    ],
    "[V][Conc][Trns][A_4Sg][P_2Pl]": [
        "@–nger+mici"
    ],
    "[V][Conc][Trns][A_4Sg][P_2Sg]": [
        "@–nger+miten"
    ],
    "[V][Conc][Trns][A_4Sg][P_3Du]": [
        "@–nger+mikek"
    ],
    "[V][Conc][Trns][A_4Sg][P_3Pl]": [
        "@–nger+miki"
    ],
    "[V][Conc][Trns][A_4Sg][P_3Sg]": [
        "@–nger+miu"
    ],
    "[V][Cond][Intr][S_1Du]": [
        "@~–ku–megnuk"
    ],
    "[V][Cond][Intr][S_1Pl]": [
        "@~–ku–mta"
    ],
    "[V][Cond][Intr][S_1Sg]": [
        "@~–ku+ma"
    ],
    "[V][Cond][Intr][S_2Du]": [
        "@~–ku.vtek"
    ],
    "[V][Cond][Intr][S_2Pl]": [
        "@~–ku.veci"
    ],
    "[V][Cond][Intr][S_2Sg]": [
        "@~–ku.vet"
    ],
    "[V][Cond][Intr][S_3Du]": [
        "@~–ku:agnek"
    ],
    "[V][Cond][Intr][S_3Pl]": [
        "@~–ku:ata"
    ],
    "[V][Cond][Intr][S_3Sg]": [
        "@~–ku:an"
    ],
    "[V][Cond][Intr][S_4Du]": [
        "@~–ku+nek"
    ],
    "[V][Cond][Intr][S_4Pl]": [
        "@~–ku+neng"
    ],
    "[V][Cond][Intr][S_4Sg]": [
        "@~–ku+ni"
    ],
    "[V][Cond][Trns][A_1Du][P_2Du]": [
        "@~–ku–megtek"
    ],
    "[V][Cond][Trns][A_1Du][P_2Pl]": [
        "@~–ku–megci"
    ],
    "[V][Cond][Trns][A_1Du][P_2Sg]": [
        "@~–ku–megten"
    ],
    "[V][Cond][Trns][A_1Du][P_3Du]": [
        "@~–ku–megkek"
    ],
    "[V][Cond][Trns][A_1Du][P_3Pl]": [
        "@~–ku–megki"
    ],
    "[V][Cond][Trns][A_1Du][P_3Sg]": [
        "@~–ku–megnegu"
    ],
    "[V][Cond][Trns][A_1Du][P_4Du]": [
        "@~–ku–megtek"
    ],
    "[V][Cond][Trns][A_1Du][P_4Pl]": [
        "@~–ku–megteng"
    ],
    "[V][Cond][Trns][A_1Du][P_4Sg]": [
        "@~–ku–megni"
    ],
    "[V][Cond][Trns][A_1Pl][P_2Du]": [
        "@~–ku–mcetek"
    ],
    "[V][Cond][Trns][A_1Pl][P_2Pl]": [
        "@~–ku–mceci"
    ],
    "[V][Cond][Trns][A_1Pl][P_2Sg]": [
        "@~–ku–mteggen"
    ],
    "[V][Cond][Trns][A_1Pl][P_3Du]": [
        "@~–ku–mtekek"
    ],
    "[V][Cond][Trns][A_1Pl][P_3Pl]": [
        "@~–ku–mteki"
    ],
    "[V][Cond][Trns][A_1Pl][P_3Sg]": [
        "@~–ku–mteggu"
    ],
    "[V][Cond][Trns][A_1Pl][P_4Du]": [
        "@~–ku–mcetek"
    ],
    "[V][Cond][Trns][A_1Pl][P_4Pl]": [
        "@~–ku–mceteng"
    ],
    "[V][Cond][Trns][A_1Pl][P_4Sg]": [
        "@~–ku–mten̄i"
    ],
    "[V][Cond][Trns][A_1Sg][P_2Du]": [
        "@~–ku–mtek"
    ],
    "[V][Cond][Trns][A_1Sg][P_2Pl]": [
        "@~–ku–mci"
    ],
    "[V][Cond][Trns][A_1Sg][P_2Sg]": [
        "@~–ku–mken"
    ],
    "[V][Cond][Trns][A_1Sg][P_3Du]": [
        "@~–ku–mkek"
    ],
    "[V][Cond][Trns][A_1Sg][P_3Pl]": [
        "@~–ku–mki"
    ],
    "[V][Cond][Trns][A_1Sg][P_3Sg]": [
        "@~–ku–mku"
    ],
    "[V][Cond][Trns][A_1Sg][P_4Du]": [
        "@~–ku–mtek"
    ],
    "[V][Cond][Trns][A_1Sg][P_4Pl]": [
        "@~–ku–mteng"
    ],
    "[V][Cond][Trns][A_1Sg][P_4Sg]": [
        "@~–ku–mni"
    ],
    "[V][Cond][Trns][A_2Du][P_1Du]": [
        "@~–ku.vtegkuk"
    ],
    "[V][Cond][Trns][A_2Du][P_1Pl]": [
        "@~–ku.vtegkut"
    ],
    "[V][Cond][Trns][A_2Du][P_1Sg]": [
        "@~–ku.vtegnga"
    ],
    "[V][Cond][Trns][A_2Du][P_3Du]": [
        "@~–ku.vtegkek"
    ],
    "[V][Cond][Trns][A_2Du][P_3Pl]": [
        "@~–ku.vtegki"
    ],
    "[V][Cond][Trns][A_2Du][P_3Sg]": [
        "@~–ku.vtegnegu"
    ],
    "[V][Cond][Trns][A_2Du][P_4Du]": [
        "@~–ku.vtegtek"
    ],
    "[V][Cond][Trns][A_2Du][P_4Pl]": [
        "@~–ku.vtegteng"
    ],
    "[V][Cond][Trns][A_2Du][P_4Sg]": [
        "@~–ku.vtegni"
    ],
    "[V][Cond][Trns][A_2Pl][P_1Du]": [
        "@~–ku.vcikuk"
    ],
    "[V][Cond][Trns][A_2Pl][P_1Pl]": [
        "@~–ku.vcikut"
    ],
    "[V][Cond][Trns][A_2Pl][P_1Sg]": [
        "@~–ku.vcia"
    ],
    "[V][Cond][Trns][A_2Pl][P_3Du]": [
        "@~–ku.vcikek"
    ],
    "[V][Cond][Trns][A_2Pl][P_3Pl]": [
        "@~–ku.vciki"
    ],
    "[V][Cond][Trns][A_2Pl][P_3Sg]": [
        "@~–ku.vciu"
    ],
    "[V][Cond][Trns][A_2Pl][P_4Du]": [
        "@~–ku.vcitek"
    ],
    "[V][Cond][Trns][A_2Pl][P_4Pl]": [
        "@~–ku.vciteng"
    ],
    "[V][Cond][Trns][A_2Pl][P_4Sg]": [
        "@~–ku.vcini"
    ],
    "[V][Cond][Trns][A_2Sg][P_1Du]": [
        "@~–ku.vkuk"
    ],
    "[V][Cond][Trns][A_2Sg][P_1Pl]": [
        "@~–ku.vkut"
    ],
    "[V][Cond][Trns][A_2Sg][P_1Sg]": [
        "@~–ku.vnga"
    ],
    "[V][Cond][Trns][A_2Sg][P_3Du]": [
        "@~–ku.vkek"
    ],
    "[V][Cond][Trns][A_2Sg][P_3Pl]": [
        "@~–ku.vki"
    ],
    "[V][Cond][Trns][A_2Sg][P_3Sg]": [
        "@~–ku.vgu"
    ],
    "[V][Cond][Trns][A_2Sg][P_4Du]": [
        "@~–ku.vtek"
    ],
    "[V][Cond][Trns][A_2Sg][P_4Pl]": [
        "@~–ku.vteng"
    ],
    "[V][Cond][Trns][A_2Sg][P_4Sg]": [
        "@~–ku.vni"
    ],
    "[V][Cond][Trns][A_3Du][P_1Du]": [
        "@~–ku:agkuk"
    ],
    "[V][Cond][Trns][A_3Du][P_1Pl]": [
        "@~–ku:agkut"
    ],
    "[V][Cond][Trns][A_3Du][P_1Sg]": [
        "@~–ku:agnga"
    ],
    "[V][Cond][Trns][A_3Du][P_2Du]": [
        "@~–ku:agtek"
    ],
    "[V][Cond][Trns][A_3Du][P_2Pl]": [
        "@~–ku:agci"
    ],
    "[V][Cond][Trns][A_3Du][P_2Sg]": [
        "@~–ku:agten"
    ],
    "[V][Cond][Trns][A_3Du][P_3Du]": [
        "@~–ku:agkek"
    ],
    "[V][Cond][Trns][A_3Du][P_3Pl]": [
        "@~–ku:agki"
    ],
    "[V][Cond][Trns][A_3Du][P_3Sg]": [
        "@~–ku:agnegu"
    ],
    "[V][Cond][Trns][A_3Du][P_4Du]": [
        "@~–ku:agtek"
    ],
    "[V][Cond][Trns][A_3Du][P_4Pl]": [
        "@~–ku:agteng"
    ],
    "[V][Cond][Trns][A_3Du][P_4Sg]": [
        "@~–ku:agni"
    ],
    "[V][Cond][Trns][A_3Pl][P_1Du]": [
        "@~–ku:atkuk"
    ],
    "[V][Cond][Trns][A_3Pl][P_1Pl]": [
        "@~–ku:atkut"
    ],
    "[V][Cond][Trns][A_3Pl][P_1Sg]": [
        "@~–ku:atnga"
    ],
    "[V][Cond][Trns][A_3Pl][P_2Du]": [
        "@~–ku:acetek"
    ],
    "[V][Cond][Trns][A_3Pl][P_2Pl]": [
        "@~–ku:aceci"
    ],
    "[V][Cond][Trns][A_3Pl][P_2Sg]": [
        "@~–ku:atgen"
    ],
    "[V][Cond][Trns][A_3Pl][P_3Du]": [
        "@~–ku:atkek"
    ],
    "[V][Cond][Trns][A_3Pl][P_3Pl]": [
        "@~–ku:atki"
    ],
    "[V][Cond][Trns][A_3Pl][P_3Sg]": [
        "@~–ku:atgu"
    ],
    "[V][Cond][Trns][A_3Pl][P_4Du]": [
        "@~–ku:acetek"
    ],
    "[V][Cond][Trns][A_3Pl][P_4Pl]": [
        "@~–ku:aceteng"
    ],
    "[V][Cond][Trns][A_3Pl][P_4Sg]": [
        "@~–ku:atni"
    ],
    "[V][Cond][Trns][A_3Sg][P_1Du]": [
        "@~–ku:akuk"
    ],
    "[V][Cond][Trns][A_3Sg][P_1Pl]": [
        "@~–ku:akut"
    ],
    "[V][Cond][Trns][A_3Sg][P_1Sg]": [
        "@~–ku:anga"
    ],
    "[V][Cond][Trns][A_3Sg][P_2Du]": [
        "@~–ku:atek"
    ],
    "[V][Cond][Trns][A_3Sg][P_2Pl]": [
        "@~–ku:aci"
    ],
    "[V][Cond][Trns][A_3Sg][P_2Sg]": [
        "@~–ku:aten"
    ],
    "[V][Cond][Trns][A_3Sg][P_3Du]": [
        "@~–ku:akek"
    ],
    "[V][Cond][Trns][A_3Sg][P_3Pl]": [
        "@~–ku:aki"
    ],
    "[V][Cond][Trns][A_3Sg][P_3Sg]": [
        "@~–ku:aku"
    ],
    "[V][Cond][Trns][A_3Sg][P_4Du]": [
        "@~–ku:atek"
    ],
    "[V][Cond][Trns][A_3Sg][P_4Pl]": [
        "@~–ku:ateng"
    ],
    "[V][Cond][Trns][A_3Sg][P_4Sg]": [
        "@~–ku:ani"
    ],
    "[V][Cond][Trns][A_4Du][P_1Du]": [
        "@~–ku+negnekuk"
    ],
    "[V][Cond][Trns][A_4Du][P_1Pl]": [
        "@~–ku+negnekut"
    ],
    "[V][Cond][Trns][A_4Du][P_1Sg]": [
        "@~–ku+negnenga"
    ],
    "[V][Cond][Trns][A_4Du][P_2Du]": [
        "@~–ku+negnetek"
    ],
    "[V][Cond][Trns][A_4Du][P_2Pl]": [
        "@~–ku+negneci"
    ],
    "[V][Cond][Trns][A_4Du][P_2Sg]": [
        "@~–ku+negnegen"
    ],
    "[V][Cond][Trns][A_4Du][P_3Du]": [
        "@~–ku+negnekek"
    ],
    "[V][Cond][Trns][A_4Du][P_3Pl]": [
        "@~–ku+negneki"
    ],
    "[V][Cond][Trns][A_4Du][P_3Sg]": [
        "@~–ku+negnegu"
    ],
    "[V][Cond][Trns][A_4Pl][P_1Du]": [
        "@~–ku+negtekuk"
    ],
    "[V][Cond][Trns][A_4Pl][P_1Pl]": [
        "@~–ku+negtekut"
    ],
    "[V][Cond][Trns][A_4Pl][P_1Sg]": [
        "@~–ku+negtenga"
    ],
    "[V][Cond][Trns][A_4Pl][P_2Du]": [
        "@~–ku+negcetek"
    ],
    "[V][Cond][Trns][A_4Pl][P_2Pl]": [
        "@~–ku+negceci"
    ],
    "[V][Cond][Trns][A_4Pl][P_2Sg]": [
        "@~–ku+negteggen"
    ],
    "[V][Cond][Trns][A_4Pl][P_3Du]": [
        "@~–ku+negtekek"
    ],
    "[V][Cond][Trns][A_4Pl][P_3Pl]": [
        "@~–ku+negteki"
    ],
    "[V][Cond][Trns][A_4Pl][P_3Sg]": [
        "@~–ku+negteggu"
    ],
    "[V][Cond][Trns][A_4Sg][P_1Du]": [
        "@~–ku+nikuk"
    ],
    "[V][Cond][Trns][A_4Sg][P_1Pl]": [
        "@~–ku+nikut"
    ],
    "[V][Cond][Trns][A_4Sg][P_1Sg]": [
        "@~–ku+nia"
    ],
    "[V][Cond][Trns][A_4Sg][P_2Du]": [
        "@~–ku+nitek"
    ],
    "[V][Cond][Trns][A_4Sg][P_2Pl]": [
        "@~–ku+nici"
    ],
    "[V][Cond][Trns][A_4Sg][P_2Sg]": [
        "@~–ku+niten"
    ],
    "[V][Cond][Trns][A_4Sg][P_3Du]": [
        "@~–ku+nikek"
    ],
    "[V][Cond][Trns][A_4Sg][P_3Pl]": [
        "@~–ku+niki"
    ],
    "[V][Cond][Trns][A_4Sg][P_3Sg]": [
        "@~–ku+niu"
    ],
    "[V][Cont][Intr][S_1Du]": [
        "+'(g)aqa–megnuk"
    ],
    "[V][Cont][Intr][S_1Pl]": [
        "+'(g)aqa–mta"
    ],
    "[V][Cont][Intr][S_1Sg]": [
        "+'(g)aqa+ma"
    ],
    "[V][Cont][Intr][S_2Du]": [
        "+'(g)aqa.vtek"
    ],
    "[V][Cont][Intr][S_2Pl]": [
        "+'(g)aqa.veci"
    ],
    "[V][Cont][Intr][S_2Sg]": [
        "+'(g)aqa.vet"
    ],
    "[V][Cont][Intr][S_3Du]": [
        "+'(g)aqa:agnek"
    ],
    "[V][Cont][Intr][S_3Pl]": [
        "+'(g)aqa:ata"
    ],
    "[V][Cont][Intr][S_3Sg]": [
        "+'(g)aqa:an"
    ],
    "[V][Cont][Intr][S_4Du]": [
        "+'(g)aqa+mek"
    ],
    "[V][Cont][Intr][S_4Pl]": [
        "+'(g)aqa+meng"
    ],
    "[V][Cont][Intr][S_4Sg]": [
        "+'(g)aqa+mi"
    ],
    "[V][Cont][Trns][A_1Du][P_2Du]": [
        "+'(g)aqa–megtek"
    ],
    "[V][Cont][Trns][A_1Du][P_2Pl]": [
        "+'(g)aqa–megci"
    ],
    "[V][Cont][Trns][A_1Du][P_2Sg]": [
        "+'(g)aqa–megten"
    ],
    "[V][Cont][Trns][A_1Du][P_3Du]": [
        "+'(g)aqa–megkek"
    ],
    "[V][Cont][Trns][A_1Du][P_3Pl]": [
        "+'(g)aqa–megki"
    ],
    "[V][Cont][Trns][A_1Du][P_3Sg]": [
        "+'(g)aqa–megnegu"
    ],
    "[V][Cont][Trns][A_1Du][P_4Du]": [
        "+'(g)aqa–megtek"
    ],
    "[V][Cont][Trns][A_1Du][P_4Pl]": [
        "+'(g)aqa–megteng"
    ],
    "[V][Cont][Trns][A_1Du][P_4Sg]": [
        "+'(g)aqa–megni"
    ],
    "[V][Cont][Trns][A_1Pl][P_2Du]": [
        "+'(g)aqa–mcetek"
    ],
    "[V][Cont][Trns][A_1Pl][P_2Pl]": [
        "+'(g)aqa–mceci"
    ],
    "[V][Cont][Trns][A_1Pl][P_2Sg]": [
        "+'(g)aqa–mteggen"
    ],
    "[V][Cont][Trns][A_1Pl][P_3Du]": [
        "+'(g)aqa–mtekek"
    ],
    "[V][Cont][Trns][A_1Pl][P_3Pl]": [
        "+'(g)aqa–mteki"
    ],
    "[V][Cont][Trns][A_1Pl][P_3Sg]": [
        "+'(g)aqa–mteggu"
    ],
    "[V][Cont][Trns][A_1Pl][P_4Du]": [
        "+'(g)aqa–mcetek"
    ],
    "[V][Cont][Trns][A_1Pl][P_4Pl]": [
        "+'(g)aqa–mceteng"
    ],
    "[V][Cont][Trns][A_1Pl][P_4Sg]": [
        "+'(g)aqa–mten̄i"
    ],
    "[V][Cont][Trns][A_1Sg][P_2Du]": [
        "+'(g)aqa–mtek"
    ],
    "[V][Cont][Trns][A_1Sg][P_2Pl]": [
        "+'(g)aqa–mci"
    ],
    "[V][Cont][Trns][A_1Sg][P_2Sg]": [
        "+'(g)aqa–mken"
    ],
    "[V][Cont][Trns][A_1Sg][P_3Du]": [
        "+'(g)aqa–mkek"
    ],
    "[V][Cont][Trns][A_1Sg][P_3Pl]": [
        "+'(g)aqa–mki"
    ],
    "[V][Cont][Trns][A_1Sg][P_3Sg]": [
        "+'(g)aqa–mku"
    ],
    "[V][Cont][Trns][A_1Sg][P_4Du]": [
        "+'(g)aqa–mtek"
    ],
    "[V][Cont][Trns][A_1Sg][P_4Pl]": [
        "+'(g)aqa–mteng"
    ],
    "[V][Cont][Trns][A_1Sg][P_4Sg]": [
        "+'(g)aqa–mni"
    ],
    "[V][Cont][Trns][A_2Du][P_1Du]": [
        "+'(g)aqa.vtegkuk"
    ],
    "[V][Cont][Trns][A_2Du][P_1Pl]": [
        "+'(g)aqa.vtegkut"
    ],
    "[V][Cont][Trns][A_2Du][P_1Sg]": [
        "+'(g)aqa.vtegnga"
    ],
    "[V][Cont][Trns][A_2Du][P_3Du]": [
        "+'(g)aqa.vtegkek"
    ],
    "[V][Cont][Trns][A_2Du][P_3Pl]": [
        "+'(g)aqa.vtegki"
    ],
    "[V][Cont][Trns][A_2Du][P_3Sg]": [
        "+'(g)aqa.vtegnegu"
    ],
    "[V][Cont][Trns][A_2Du][P_4Du]": [
        "+'(g)aqa.vtegtek"
    ],
    "[V][Cont][Trns][A_2Du][P_4Pl]": [
        "+'(g)aqa.vtegteng"
    ],
    "[V][Cont][Trns][A_2Du][P_4Sg]": [
        "+'(g)aqa.vtegni"
    ],
    "[V][Cont][Trns][A_2Pl][P_1Du]": [
        "+'(g)aqa.vcikuk"
    ],
    "[V][Cont][Trns][A_2Pl][P_1Pl]": [
        "+'(g)aqa.vcikut"
    ],
    "[V][Cont][Trns][A_2Pl][P_1Sg]": [
        "+'(g)aqa.vcia"
    ],
    "[V][Cont][Trns][A_2Pl][P_3Du]": [
        "+'(g)aqa.vcikek"
    ],
    "[V][Cont][Trns][A_2Pl][P_3Pl]": [
        "+'(g)aqa.vciki"
    ],
    "[V][Cont][Trns][A_2Pl][P_3Sg]": [
        "+'(g)aqa.vciu"
    ],
    "[V][Cont][Trns][A_2Pl][P_4Du]": [
        "+'(g)aqa.vcitek"
    ],
    "[V][Cont][Trns][A_2Pl][P_4Pl]": [
        "+'(g)aqa.vciteng"
    ],
    "[V][Cont][Trns][A_2Pl][P_4Sg]": [
        "+'(g)aqa.vcini"
    ],
    "[V][Cont][Trns][A_2Sg][P_1Du]": [
        "+'(g)aqa.vkuk"
    ],
    "[V][Cont][Trns][A_2Sg][P_1Pl]": [
        "+'(g)aqa.vkut"
    ],
    "[V][Cont][Trns][A_2Sg][P_1Sg]": [
        "+'(g)aqa.vnga"
    ],
    "[V][Cont][Trns][A_2Sg][P_3Du]": [
        "+'(g)aqa.vkek"
    ],
    "[V][Cont][Trns][A_2Sg][P_3Pl]": [
        "+'(g)aqa.vki"
    ],
    "[V][Cont][Trns][A_2Sg][P_3Sg]": [
        "+'(g)aqa.vgu"
    ],
    "[V][Cont][Trns][A_2Sg][P_4Du]": [
        "+'(g)aqa.vtek"
    ],
    "[V][Cont][Trns][A_2Sg][P_4Pl]": [
        "+'(g)aqa.vteng"
    ],
    "[V][Cont][Trns][A_2Sg][P_4Sg]": [
        "+'(g)aqa.vni"
    ],
    "[V][Cont][Trns][A_3Du][P_1Du]": [
        "+'(g)aqa:agkuk"
    ],
    "[V][Cont][Trns][A_3Du][P_1Pl]": [
        "+'(g)aqa:agkut"
    ],
    "[V][Cont][Trns][A_3Du][P_1Sg]": [
        "+'(g)aqa:agnga"
    ],
    "[V][Cont][Trns][A_3Du][P_2Du]": [
        "+'(g)aqa:agtek"
    ],
    "[V][Cont][Trns][A_3Du][P_2Pl]": [
        "+'(g)aqa:agci"
    ],
    "[V][Cont][Trns][A_3Du][P_2Sg]": [
        "+'(g)aqa:agten"
    ],
    "[V][Cont][Trns][A_3Du][P_3Du]": [
        "+'(g)aqa:agkek"
    ],
    "[V][Cont][Trns][A_3Du][P_3Pl]": [
        "+'(g)aqa:agki"
    ],
    "[V][Cont][Trns][A_3Du][P_3Sg]": [
        "+'(g)aqa:agnegu"
    ],
    "[V][Cont][Trns][A_3Du][P_4Du]": [
        "+'(g)aqa:agtek"
    ],
    "[V][Cont][Trns][A_3Du][P_4Pl]": [
        "+'(g)aqa:agteng"
    ],
    "[V][Cont][Trns][A_3Du][P_4Sg]": [
        "+'(g)aqa:agni"
    ],
    "[V][Cont][Trns][A_3Pl][P_1Du]": [
        "+'(g)aqa:atkuk"
    ],
    "[V][Cont][Trns][A_3Pl][P_1Pl]": [
        "+'(g)aqa:atkut"
    ],
    "[V][Cont][Trns][A_3Pl][P_1Sg]": [
        "+'(g)aqa:atnga"
    ],
    "[V][Cont][Trns][A_3Pl][P_2Du]": [
        "+'(g)aqa:acetek"
    ],
    "[V][Cont][Trns][A_3Pl][P_2Pl]": [
        "+'(g)aqa:aceci"
    ],
    "[V][Cont][Trns][A_3Pl][P_2Sg]": [
        "+'(g)aqa:atgen"
    ],
    "[V][Cont][Trns][A_3Pl][P_3Du]": [
        "+'(g)aqa:atkek"
    ],
    "[V][Cont][Trns][A_3Pl][P_3Pl]": [
        "+'(g)aqa:atki"
    ],
    "[V][Cont][Trns][A_3Pl][P_3Sg]": [
        "+'(g)aqa:atgu"
    ],
    "[V][Cont][Trns][A_3Pl][P_4Du]": [
        "+'(g)aqa:acetek"
    ],
    "[V][Cont][Trns][A_3Pl][P_4Pl]": [
        "+'(g)aqa:aceteng"
    ],
    "[V][Cont][Trns][A_3Pl][P_4Sg]": [
        "+'(g)aqa:atni"
    ],
    "[V][Cont][Trns][A_3Sg][P_1Du]": [
        "+'(g)aqa:akuk"
    ],
    "[V][Cont][Trns][A_3Sg][P_1Pl]": [
        "+'(g)aqa:akut"
    ],
    "[V][Cont][Trns][A_3Sg][P_1Sg]": [
        "+'(g)aqa:anga"
    ],
    "[V][Cont][Trns][A_3Sg][P_2Du]": [
        "+'(g)aqa:atek"
    ],
    "[V][Cont][Trns][A_3Sg][P_2Pl]": [
        "+'(g)aqa:aci"
    ],
    "[V][Cont][Trns][A_3Sg][P_2Sg]": [
        "+'(g)aqa:aten"
    ],
    "[V][Cont][Trns][A_3Sg][P_3Du]": [
        "+'(g)aqa:akek"
    ],
    "[V][Cont][Trns][A_3Sg][P_3Pl]": [
        "+'(g)aqa:aki"
    ],
    "[V][Cont][Trns][A_3Sg][P_3Sg]": [
        "+'(g)aqa:aku"
    ],
    "[V][Cont][Trns][A_3Sg][P_4Du]": [
        "+'(g)aqa:atek"
    ],
    "[V][Cont][Trns][A_3Sg][P_4Pl]": [
        "+'(g)aqa:ateng"
    ],
    "[V][Cont][Trns][A_3Sg][P_4Sg]": [
        "+'(g)aqa:ani"
    ],
    "[V][Cont][Trns][A_4Du][P_1Du]": [
        "+'(g)aqa+megnekuk"
    ],
    "[V][Cont][Trns][A_4Du][P_1Pl]": [
        "+'(g)aqa+megnekut"
    ],
    "[V][Cont][Trns][A_4Du][P_1Sg]": [
        "+'(g)aqa+megnenga"
    ],
    "[V][Cont][Trns][A_4Du][P_2Du]": [
        "+'(g)aqa+megnetek"
    ],
    "[V][Cont][Trns][A_4Du][P_2Pl]": [
        "+'(g)aqa+megneci"
    ],
    "[V][Cont][Trns][A_4Du][P_2Sg]": [
        "+'(g)aqa+megnegen"
    ],
    "[V][Cont][Trns][A_4Du][P_3Du]": [
        "+'(g)aqa+megnekek"
    ],
    "[V][Cont][Trns][A_4Du][P_3Pl]": [
        "+'(g)aqa+megneki"
    ],
    "[V][Cont][Trns][A_4Du][P_3Sg]": [
        "+'(g)aqa+megnegu"
    ],
    "[V][Cont][Trns][A_4Pl][P_1Du]": [
        "+'(g)aqa+megtekuk"
    ],
    "[V][Cont][Trns][A_4Pl][P_1Pl]": [
        "+'(g)aqa+megtekut"
    ],
    "[V][Cont][Trns][A_4Pl][P_1Sg]": [
        "+'(g)aqa+megtenga"
    ],
    "[V][Cont][Trns][A_4Pl][P_2Du]": [
        "+'(g)aqa+megcetek"
    ],
    "[V][Cont][Trns][A_4Pl][P_2Pl]": [
        "+'(g)aqa+megceci"
    ],
    "[V][Cont][Trns][A_4Pl][P_2Sg]": [
        "+'(g)aqa+megteggen"
    ],
    "[V][Cont][Trns][A_4Pl][P_3Du]": [
        "+'(g)aqa+megtekek"
    ],
    "[V][Cont][Trns][A_4Pl][P_3Pl]": [
        "+'(g)aqa+megteki"
    ],
    "[V][Cont][Trns][A_4Pl][P_3Sg]": [
        "+'(g)aqa+megteggu"
    ],
    "[V][Cont][Trns][A_4Sg][P_1Du]": [
        "+'(g)aqa+mikuk"
    ],
    "[V][Cont][Trns][A_4Sg][P_1Pl]": [
        "+'(g)aqa+mikut"
    ],
    "[V][Cont][Trns][A_4Sg][P_1Sg]": [
        "+'(g)aqa+mia"
    ],
    "[V][Cont][Trns][A_4Sg][P_2Du]": [
        "+'(g)aqa+mitek"
    ],
    "[V][Cont][Trns][A_4Sg][P_2Pl]": [
        "+'(g)aqa+mici"
    ],
    "[V][Cont][Trns][A_4Sg][P_2Sg]": [
        "+'(g)aqa+miten"
    ],
    "[V][Cont][Trns][A_4Sg][P_3Du]": [
        "+'(g)aqa+mikek"
    ],
    "[V][Cont][Trns][A_4Sg][P_3Pl]": [
        "+'(g)aqa+miki"
    ],
    "[V][Cont][Trns][A_4Sg][P_3Sg]": [
        "+'(g)aqa+miu"
    ],
    "[V][CtmpII][Intr][S_1Du]": [
        "@%:(ng)inaner–megni",
        "@~+nginaner–megni"
    ],
    "[V][CtmpII][Intr][S_1Pl]": [
        "@%:(ng)inaner–mten̄i",
        "@~+nginaner–mten̄i"
    ],
    "[V][CtmpII][Intr][S_1Sg]": [
        "@%:(ng)inaner–mni",
        "@~+nginaner–mni"
    ],
    "[V][CtmpII][Intr][S_2Du]": [
        "@%:(ng)inaner+petegni",
        "@~+nginaner+petegni"
    ],
    "[V][CtmpII][Intr][S_2Pl]": [
        "@%:(ng)inaner+pecen̄i",
        "@~+nginaner+pecen̄i"
    ],
    "[V][CtmpII][Intr][S_2Sg]": [
        "@%:(ng)inaner+peni",
        "@~+nginaner+peni"
    ],
    "[V][CtmpII][Intr][S_3Du]": [
        "@%:(ng)inaner:agni",
        "@~+nginaner:agni"
    ],
    "[V][CtmpII][Intr][S_3Pl]": [
        "@%:(ng)inaner:atni",
        "@~+nginaner:atni"
    ],
    "[V][CtmpII][Intr][S_3Sg]": [
        "@%:(ng)inaner:ani",
        "@~+nginaner:ani"
    ],
    "[V][CtmpII][Intr][S_4Du]": [
        "@%:(ng)inaner+megni",
        "@~+nginaner+megni"
    ],
    "[V][CtmpII][Intr][S_4Pl]": [
        "@%:(ng)inaner+meggni",
        "@~+nginaner+meggni"
    ],
    "[V][CtmpII][Intr][S_4Sg]": [
        "@%:(ng)inaner+mini",
        "@~+nginaner+mini"
    ],
    "[V][CtmpII][Trns][A_1Du][P_2Du]": [
        "@%:(ng)inaner–megtek",
        "@~+nginaner–megtek"
    ],
    "[V][CtmpII][Trns][A_1Du][P_2Pl]": [
        "@%:(ng)inaner–megci",
        "@~+nginaner–megci"
    ],
    "[V][CtmpII][Trns][A_1Du][P_2Sg]": [
        "@%:(ng)inaner–megten",
        "@~+nginaner–megten"
    ],
    "[V][CtmpII][Trns][A_1Du][P_3Du]": [
        "@%:(ng)inaner–megkek",
        "@~+nginaner–megkek"
    ],
    "[V][CtmpII][Trns][A_1Du][P_3Pl]": [
        "@%:(ng)inaner–megki",
        "@~+nginaner–megki"
    ],
    "[V][CtmpII][Trns][A_1Du][P_3Sg]": [
        "@%:(ng)inaner–megnegu",
        "@~+nginaner–megnegu"
    ],
    "[V][CtmpII][Trns][A_1Du][P_4Du]": [
        "@%:(ng)inaner–megtek",
        "@~+nginaner–megtek"
    ],
    "[V][CtmpII][Trns][A_1Du][P_4Pl]": [
        "@%:(ng)inaner–megteng",
        "@~+nginaner–megteng"
    ],
    "[V][CtmpII][Trns][A_1Du][P_4Sg]": [
        "@%:(ng)inaner–megni",
        "@~+nginaner–megni"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_2Du]": [
        "@%:(ng)inaner–mcetek",
        "@~+nginaner–mcetek"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_2Pl]": [
        "@%:(ng)inaner–mceci",
        "@~+nginaner–mceci"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_2Sg]": [
        "@%:(ng)inaner–mteggen",
        "@~+nginaner–mteggen"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_3Du]": [
        "@%:(ng)inaner–mtekek",
        "@~+nginaner–mtekek"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_3Pl]": [
        "@%:(ng)inaner–mteki",
        "@~+nginaner–mteki"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_3Sg]": [
        "@%:(ng)inaner–mteggu",
        "@~+nginaner–mteggu"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_4Du]": [
        "@%:(ng)inaner–mcetek",
        "@~+nginaner–mcetek"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_4Pl]": [
        "@%:(ng)inaner–mceteng",
        "@~+nginaner–mceteng"
    ],
    "[V][CtmpII][Trns][A_1Pl][P_4Sg]": [
        "@%:(ng)inaner–mten̄i",
        "@~+nginaner–mten̄i"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_2Du]": [
        "@%:(ng)inaner–mtek",
        "@~+nginaner–mtek"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_2Pl]": [
        "@%:(ng)inaner–mci",
        "@~+nginaner–mci"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_2Sg]": [
        "@%:(ng)inaner–mken",
        "@~+nginaner–mken"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_3Du]": [
        "@%:(ng)inaner–mkek",
        "@~+nginaner–mkek"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_3Pl]": [
        "@%:(ng)inaner–mki",
        "@~+nginaner–mki"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_3Sg]": [
        "@%:(ng)inaner–mku",
        "@~+nginaner–mku"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_4Du]": [
        "@%:(ng)inaner–mtek",
        "@~+nginaner–mtek"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_4Pl]": [
        "@%:(ng)inaner–mteng",
        "@~+nginaner–mteng"
    ],
    "[V][CtmpII][Trns][A_1Sg][P_4Sg]": [
        "@%:(ng)inaner–mni",
        "@~+nginaner–mni"
    ],
    "[V][CtmpII][Trns][A_2Du][P_1Du]": [
        "@%:(ng)inaner+petegkuk",
        "@~+nginaner+petegkuk"
    ],
    "[V][CtmpII][Trns][A_2Du][P_1Pl]": [
        "@%:(ng)inaner+petegkut",
        "@~+nginaner+petegkut"
    ],
    "[V][CtmpII][Trns][A_2Du][P_1Sg]": [
        "@%:(ng)inaner+petegnga",
        "@~+nginaner+petegnga"
    ],
    "[V][CtmpII][Trns][A_2Du][P_3Du]": [
        "@%:(ng)inaner+petegkek",
        "@~+nginaner+petegkek"
    ],
    "[V][CtmpII][Trns][A_2Du][P_3Pl]": [
        "@%:(ng)inaner+petegki",
        "@~+nginaner+petegki"
    ],
    "[V][CtmpII][Trns][A_2Du][P_3Sg]": [
        "@%:(ng)inaner+petegnegu",
        "@~+nginaner+petegnegu"
    ],
    "[V][CtmpII][Trns][A_2Du][P_4Du]": [
        "@%:(ng)inaner+petegtek",
        "@~+nginaner+petegtek"
    ],
    "[V][CtmpII][Trns][A_2Du][P_4Pl]": [
        "@%:(ng)inaner+petegteng",
        "@~+nginaner+petegteng"
    ],
    "[V][CtmpII][Trns][A_2Du][P_4Sg]": [
        "@%:(ng)inaner+petegni",
        "@~+nginaner+petegni"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_1Du]": [
        "@%:(ng)inaner+pecikuk",
        "@~+nginaner+pecikuk"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_1Pl]": [
        "@%:(ng)inaner+pecikut",
        "@~+nginaner+pecikut"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_1Sg]": [
        "@%:(ng)inaner+pecia",
        "@~+nginaner+pecia"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_3Du]": [
        "@%:(ng)inaner+pecikek",
        "@~+nginaner+pecikek"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_3Pl]": [
        "@%:(ng)inaner+peciki",
        "@~+nginaner+peciki"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_3Sg]": [
        "@%:(ng)inaner+peciu",
        "@~+nginaner+peciu"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_4Du]": [
        "@%:(ng)inaner+pecitek",
        "@~+nginaner+pecitek"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_4Pl]": [
        "@%:(ng)inaner+peciteng",
        "@~+nginaner+peciteng"
    ],
    "[V][CtmpII][Trns][A_2Pl][P_4Sg]": [
        "@%:(ng)inaner+pecini",
        "@~+nginaner+pecini"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_1Du]": [
        "@%:(ng)inaner+pekuk",
        "@~+nginaner+pekuk"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_1Pl]": [
        "@%:(ng)inaner+pekut",
        "@~+nginaner+pekut"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_1Sg]": [
        "@%:(ng)inaner+penga",
        "@~+nginaner+penga"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_3Du]": [
        "@%:(ng)inaner+pekek",
        "@~+nginaner+pekek"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_3Pl]": [
        "@%:(ng)inaner+peki",
        "@~+nginaner+peki"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_3Sg]": [
        "@%:(ng)inaner+pegu",
        "@~+nginaner+pegu"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_4Du]": [
        "@%:(ng)inaner+petek",
        "@~+nginaner+petek"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_4Pl]": [
        "@%:(ng)inaner+peteng",
        "@~+nginaner+peteng"
    ],
    "[V][CtmpII][Trns][A_2Sg][P_4Sg]": [
        "@%:(ng)inaner+peni",
        "@~+nginaner+peni"
    ],
    "[V][CtmpII][Trns][A_3Du][P_1Du]": [
        "@%:(ng)inaner:agkuk",
        "@~+nginaner:agkuk"
    ],
    "[V][CtmpII][Trns][A_3Du][P_1Pl]": [
        "@%:(ng)inaner:agkut",
        "@~+nginaner:agkut"
    ],
    "[V][CtmpII][Trns][A_3Du][P_1Sg]": [
        "@%:(ng)inaner:agnga",
        "@~+nginaner:agnga"
    ],
    "[V][CtmpII][Trns][A_3Du][P_2Du]": [
        "@%:(ng)inaner:agtek",
        "@~+nginaner:agtek"
    ],
    "[V][CtmpII][Trns][A_3Du][P_2Pl]": [
        "@%:(ng)inaner:agci",
        "@~+nginaner:agci"
    ],
    "[V][CtmpII][Trns][A_3Du][P_2Sg]": [
        "@%:(ng)inaner:agten",
        "@~+nginaner:agten"
    ],
    "[V][CtmpII][Trns][A_3Du][P_3Du]": [
        "@%:(ng)inaner:agkek",
        "@~+nginaner:agkek"
    ],
    "[V][CtmpII][Trns][A_3Du][P_3Pl]": [
        "@%:(ng)inaner:agki",
        "@~+nginaner:agki"
    ],
    "[V][CtmpII][Trns][A_3Du][P_3Sg]": [
        "@%:(ng)inaner:agnegu",
        "@~+nginaner:agnegu"
    ],
    "[V][CtmpII][Trns][A_3Du][P_4Du]": [
        "@%:(ng)inaner:agtek",
        "@~+nginaner:agtek"
    ],
    "[V][CtmpII][Trns][A_3Du][P_4Pl]": [
        "@%:(ng)inaner:agteng",
        "@~+nginaner:agteng"
    ],
    "[V][CtmpII][Trns][A_3Du][P_4Sg]": [
        "@%:(ng)inaner:agni",
        "@~+nginaner:agni"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_1Du]": [
        "@%:(ng)inaner:atkuk",
        "@~+nginaner:atkuk"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_1Pl]": [
        "@%:(ng)inaner:atkut",
        "@~+nginaner:atkut"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_1Sg]": [
        "@%:(ng)inaner:atnga",
        "@~+nginaner:atnga"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_2Du]": [
        "@%:(ng)inaner:acetek",
        "@~+nginaner:acetek"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_2Pl]": [
        "@%:(ng)inaner:aceci",
        "@~+nginaner:aceci"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_2Sg]": [
        "@%:(ng)inaner:atgen",
        "@~+nginaner:atgen"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_3Du]": [
        "@%:(ng)inaner:atkek",
        "@~+nginaner:atkek"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_3Pl]": [
        "@%:(ng)inaner:atki",
        "@~+nginaner:atki"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_3Sg]": [
        "@%:(ng)inaner:atgu",
        "@~+nginaner:atgu"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_4Du]": [
        "@%:(ng)inaner:acetek",
        "@~+nginaner:acetek"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_4Pl]": [
        "@%:(ng)inaner:aceteng",
        "@~+nginaner:aceteng"
    ],
    "[V][CtmpII][Trns][A_3Pl][P_4Sg]": [
        "@%:(ng)inaner:atni",
        "@~+nginaner:atni"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_1Du]": [
        "@%:(ng)inaner:akuk",
        "@~+nginaner:akuk"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_1Pl]": [
        "@%:(ng)inaner:akut",
        "@~+nginaner:akut"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_1Sg]": [
        "@%:(ng)inaner:anga",
        "@~+nginaner:anga"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_2Du]": [
        "@%:(ng)inaner:atek",
        "@~+nginaner:atek"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_2Pl]": [
        "@%:(ng)inaner:aci",
        "@~+nginaner:aci"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_2Sg]": [
        "@%:(ng)inaner:aten",
        "@~+nginaner:aten"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_3Du]": [
        "@%:(ng)inaner:akek",
        "@~+nginaner:akek"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_3Pl]": [
        "@%:(ng)inaner:aki",
        "@~+nginaner:aki"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_3Sg]": [
        "@%:(ng)inaner:aku",
        "@~+nginaner:aku"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_4Du]": [
        "@%:(ng)inaner:atek",
        "@~+nginaner:atek"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_4Pl]": [
        "@%:(ng)inaner:ateng",
        "@~+nginaner:ateng"
    ],
    "[V][CtmpII][Trns][A_3Sg][P_4Sg]": [
        "@%:(ng)inaner:ani",
        "@~+nginaner:ani"
    ],
    "[V][CtmpII][Trns][A_4Du][P_1Du]": [
        "@%:(ng)inaner+megnekuk",
        "@~+nginaner+megnekuk"
    ],
    "[V][CtmpII][Trns][A_4Du][P_1Pl]": [
        "@%:(ng)inaner+megnekut",
        "@~+nginaner+megnekut"
    ],
    "[V][CtmpII][Trns][A_4Du][P_1Sg]": [
        "@%:(ng)inaner+megnenga",
        "@~+nginaner+megnenga"
    ],
    "[V][CtmpII][Trns][A_4Du][P_2Du]": [
        "@%:(ng)inaner+megnetek",
        "@~+nginaner+megnetek"
    ],
    "[V][CtmpII][Trns][A_4Du][P_2Pl]": [
        "@%:(ng)inaner+megneci",
        "@~+nginaner+megneci"
    ],
    "[V][CtmpII][Trns][A_4Du][P_2Sg]": [
        "@%:(ng)inaner+megnegen",
        "@~+nginaner+megnegen"
    ],
    "[V][CtmpII][Trns][A_4Du][P_3Du]": [
        "@%:(ng)inaner+megnekek",
        "@~+nginaner+megnekek"
    ],
    "[V][CtmpII][Trns][A_4Du][P_3Pl]": [
        "@%:(ng)inaner+megneki",
        "@~+nginaner+megneki"
    ],
    "[V][CtmpII][Trns][A_4Du][P_3Sg]": [
        "@%:(ng)inaner+megnegu",
        "@~+nginaner+megnegu"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_1Du]": [
        "@%:(ng)inaner+megtekuk",
        "@~+nginaner+megtekuk"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_1Pl]": [
        "@%:(ng)inaner+megtekut",
        "@~+nginaner+megtekut"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_1Sg]": [
        "@%:(ng)inaner+megtenga",
        "@~+nginaner+megtenga"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_2Du]": [
        "@%:(ng)inaner+megcetek",
        "@~+nginaner+megcetek"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_2Pl]": [
        "@%:(ng)inaner+megceci",
        "@~+nginaner+megceci"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_2Sg]": [
        "@%:(ng)inaner+megteggen",
        "@~+nginaner+megteggen"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_3Du]": [
        "@%:(ng)inaner+megtekek",
        "@~+nginaner+megtekek"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_3Pl]": [
        "@%:(ng)inaner+megteki",
        "@~+nginaner+megteki"
    ],
    "[V][CtmpII][Trns][A_4Pl][P_3Sg]": [
        "@%:(ng)inaner+megteggu",
        "@~+nginaner+megteggu"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_1Du]": [
        "@%:(ng)inaner+minikuk",
        "@~+nginaner+minikuk"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_1Pl]": [
        "@%:(ng)inaner+minikut",
        "@~+nginaner+minikut"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_1Sg]": [
        "@%:(ng)inaner+minia",
        "@~+nginaner+minia"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_2Du]": [
        "@%:(ng)inaner+minitek",
        "@~+nginaner+minitek"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_2Pl]": [
        "@%:(ng)inaner+minici",
        "@~+nginaner+minici"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_2Sg]": [
        "@%:(ng)inaner+miniten",
        "@~+nginaner+miniten"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_3Du]": [
        "@%:(ng)inaner+minikek",
        "@~+nginaner+minikek"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_3Pl]": [
        "@%:(ng)inaner+miniki",
        "@~+nginaner+miniki"
    ],
    "[V][CtmpII][Trns][A_4Sg][P_3Sg]": [
        "@%:(ng)inaner+miniu",
        "@~+nginaner+miniu"
    ],
    "[V][CtmpI][Intr][S_1Du]": [
        "–ller–megni"
    ],
    "[V][CtmpI][Intr][S_1Pl]": [
        "–ller–mten̄i"
    ],
    "[V][CtmpI][Intr][S_1Sg]": [
        "–ller–mni"
    ],
    "[V][CtmpI][Intr][S_2Du]": [
        "–ller+petegni"
    ],
    "[V][CtmpI][Intr][S_2Pl]": [
        "–ller+pecen̄i"
    ],
    "[V][CtmpI][Intr][S_2Sg]": [
        "–ller+peni"
    ],
    "[V][CtmpI][Intr][S_3Du]": [
        "–ller:agni"
    ],
    "[V][CtmpI][Intr][S_3Pl]": [
        "–ller:atni"
    ],
    "[V][CtmpI][Intr][S_3Sg]": [
        "–ller:ani"
    ],
    "[V][CtmpI][Intr][S_4Du]": [
        "–ller+megni"
    ],
    "[V][CtmpI][Intr][S_4Pl]": [
        "–ller+meggni"
    ],
    "[V][CtmpI][Intr][S_4Sg]": [
        "–ller+mini"
    ],
    "[V][CtmpI][Trns][A_1Du][P_2Du]": [
        "–ller–megtek"
    ],
    "[V][CtmpI][Trns][A_1Du][P_2Pl]": [
        "–ller–megci"
    ],
    "[V][CtmpI][Trns][A_1Du][P_2Sg]": [
        "–ller–megten"
    ],
    "[V][CtmpI][Trns][A_1Du][P_3Du]": [
        "–ller–megkek"
    ],
    "[V][CtmpI][Trns][A_1Du][P_3Pl]": [
        "–ller–megki"
    ],
    "[V][CtmpI][Trns][A_1Du][P_3Sg]": [
        "–ller–megnegu"
    ],
    "[V][CtmpI][Trns][A_1Du][P_4Du]": [
        "–ller–megtek"
    ],
    "[V][CtmpI][Trns][A_1Du][P_4Pl]": [
        "–ller–megteng"
    ],
    "[V][CtmpI][Trns][A_1Du][P_4Sg]": [
        "–ller–megni"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_2Du]": [
        "–ller–mcetek"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_2Pl]": [
        "–ller–mceci"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_2Sg]": [
        "–ller–mteggen"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_3Du]": [
        "–ller–mtekek"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_3Pl]": [
        "–ller–mteki"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_3Sg]": [
        "–ller–mteggu"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_4Du]": [
        "–ller–mcetek"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_4Pl]": [
        "–ller–mceteng"
    ],
    "[V][CtmpI][Trns][A_1Pl][P_4Sg]": [
        "–ller–mten̄i"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_2Du]": [
        "–ller–mtek"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_2Pl]": [
        "–ller–mci"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_2Sg]": [
        "–ller–mken"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_3Du]": [
        "–ller–mkek"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_3Pl]": [
        "–ller–mki"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_3Sg]": [
        "–ller–mku"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_4Du]": [
        "–ller–mtek"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_4Pl]": [
        "–ller–mteng"
    ],
    "[V][CtmpI][Trns][A_1Sg][P_4Sg]": [
        "–ller–mni"
    ],
    "[V][CtmpI][Trns][A_2Du][P_1Du]": [
        "–ller+petegkuk"
    ],
    "[V][CtmpI][Trns][A_2Du][P_1Pl]": [
        "–ller+petegkut"
    ],
    "[V][CtmpI][Trns][A_2Du][P_1Sg]": [
        "–ller+petegnga"
    ],
    "[V][CtmpI][Trns][A_2Du][P_3Du]": [
        "–ller+petegkek"
    ],
    "[V][CtmpI][Trns][A_2Du][P_3Pl]": [
        "–ller+petegki"
    ],
    "[V][CtmpI][Trns][A_2Du][P_3Sg]": [
        "–ller+petegnegu"
    ],
    "[V][CtmpI][Trns][A_2Du][P_4Du]": [
        "–ller+petegtek"
    ],
    "[V][CtmpI][Trns][A_2Du][P_4Pl]": [
        "–ller+petegteng"
    ],
    "[V][CtmpI][Trns][A_2Du][P_4Sg]": [
        "–ller+petegni"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_1Du]": [
        "–ller+pecikuk"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_1Pl]": [
        "–ller+pecikut"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_1Sg]": [
        "–ller+pecia"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_3Du]": [
        "–ller+pecikek"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_3Pl]": [
        "–ller+peciki"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_3Sg]": [
        "–ller+peciu"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_4Du]": [
        "–ller+pecitek"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_4Pl]": [
        "–ller+peciteng"
    ],
    "[V][CtmpI][Trns][A_2Pl][P_4Sg]": [
        "–ller+pecini"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_1Du]": [
        "–ller+pekuk"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_1Pl]": [
        "–ller+pekut"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_1Sg]": [
        "–ller+penga"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_3Du]": [
        "–ller+pekek"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_3Pl]": [
        "–ller+peki"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_3Sg]": [
        "–ller+pegu"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_4Du]": [
        "–ller+petek"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_4Pl]": [
        "–ller+peteng"
    ],
    "[V][CtmpI][Trns][A_2Sg][P_4Sg]": [
        "–ller+peni"
    ],
    "[V][CtmpI][Trns][A_3Du][P_1Du]": [
        "–ller:agkuk"
    ],
    "[V][CtmpI][Trns][A_3Du][P_1Pl]": [
        "–ller:agkut"
    ],
    "[V][CtmpI][Trns][A_3Du][P_1Sg]": [
        "–ller:agnga"
    ],
    "[V][CtmpI][Trns][A_3Du][P_2Du]": [
        "–ller:agtek"
    ],
    "[V][CtmpI][Trns][A_3Du][P_2Pl]": [
        "–ller:agci"
    ],
    "[V][CtmpI][Trns][A_3Du][P_2Sg]": [
        "–ller:agten"
    ],
    "[V][CtmpI][Trns][A_3Du][P_3Du]": [
        "–ller:agkek"
    ],
    "[V][CtmpI][Trns][A_3Du][P_3Pl]": [
        "–ller:agki"
    ],
    "[V][CtmpI][Trns][A_3Du][P_3Sg]": [
        "–ller:agnegu"
    ],
    "[V][CtmpI][Trns][A_3Du][P_4Du]": [
        "–ller:agtek"
    ],
    "[V][CtmpI][Trns][A_3Du][P_4Pl]": [
        "–ller:agteng"
    ],
    "[V][CtmpI][Trns][A_3Du][P_4Sg]": [
        "–ller:agni"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_1Du]": [
        "–ller:atkuk"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_1Pl]": [
        "–ller:atkut"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_1Sg]": [
        "–ller:atnga"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_2Du]": [
        "–ller:acetek"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_2Pl]": [
        "–ller:aceci"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_2Sg]": [
        "–ller:atgen"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_3Du]": [
        "–ller:atkek"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_3Pl]": [
        "–ller:atki"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_3Sg]": [
        "–ller:atgu"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_4Du]": [
        "–ller:acetek"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_4Pl]": [
        "–ller:aceteng"
    ],
    "[V][CtmpI][Trns][A_3Pl][P_4Sg]": [
        "–ller:atni"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_1Du]": [
        "–ller:akuk"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_1Pl]": [
        "–ller:akut"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_1Sg]": [
        "–ller:anga"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_2Du]": [
        "–ller:atek"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_2Pl]": [
        "–ller:aci"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_2Sg]": [
        "–ller:aten"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_3Du]": [
        "–ller:akek"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_3Pl]": [
        "–ller:aki"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_3Sg]": [
        "–ller:aku"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_4Du]": [
        "–ller:atek"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_4Pl]": [
        "–ller:ateng"
    ],
    "[V][CtmpI][Trns][A_3Sg][P_4Sg]": [
        "–ller:ani"
    ],
    "[V][CtmpI][Trns][A_4Du][P_1Du]": [
        "–ller+megnekuk"
    ],
    "[V][CtmpI][Trns][A_4Du][P_1Pl]": [
        "–ller+megnekut"
    ],
    "[V][CtmpI][Trns][A_4Du][P_1Sg]": [
        "–ller+megnenga"
    ],
    "[V][CtmpI][Trns][A_4Du][P_2Du]": [
        "–ller+megnetek"
    ],
    "[V][CtmpI][Trns][A_4Du][P_2Pl]": [
        "–ller+megneci"
    ],
    "[V][CtmpI][Trns][A_4Du][P_2Sg]": [
        "–ller+megnegen"
    ],
    "[V][CtmpI][Trns][A_4Du][P_3Du]": [
        "–ller+megnekek"
    ],
    "[V][CtmpI][Trns][A_4Du][P_3Pl]": [
        "–ller+megneki"
    ],
    "[V][CtmpI][Trns][A_4Du][P_3Sg]": [
        "–ller+megnegu"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_1Du]": [
        "–ller+megtekuk"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_1Pl]": [
        "–ller+megtekut"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_1Sg]": [
        "–ller+megtenga"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_2Du]": [
        "–ller+megcetek"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_2Pl]": [
        "–ller+megceci"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_2Sg]": [
        "–ller+megteggen"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_3Du]": [
        "–ller+megtekek"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_3Pl]": [
        "–ller+megteki"
    ],
    "[V][CtmpI][Trns][A_4Pl][P_3Sg]": [
        "–ller+megteggu"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_1Du]": [
        "–ller+minikuk"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_1Pl]": [
        "–ller+minikut"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_1Sg]": [
        "–ller+minia"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_2Du]": [
        "–ller+minitek"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_2Pl]": [
        "–ller+minici"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_2Sg]": [
        "–ller+miniten"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_3Du]": [
        "–ller+minikek"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_3Pl]": [
        "–ller+miniki"
    ],
    "[V][CtmpI][Trns][A_4Sg][P_3Sg]": [
        "–ller+miniu"
    ],
    "[V][Ind][Intr][S_1Du]": [
        "+'(g/t)ukuk"
    ],
    "[V][Ind][Intr][S_1Pl]": [
        "+'(g/t)ukut"
    ],
    "[V][Ind][Intr][S_1Sg]": [
        "+'(g/t)u:nga"
    ],
    "[V][Ind][Intr][S_2Du]": [
        "+'(g/t)utek"
    ],
    "[V][Ind][Intr][S_2Pl]": [
        "+'(g/t)uci"
    ],
    "[V][Ind][Intr][S_2Sg]": [
        "+'(g/t)uten"
    ],
    "[V][Ind][Intr][S_3Du]": [
        "+'(g/t)uk"
    ],
    "[V][Ind][Intr][S_3Pl]": [
        "+'(g/t)ut"
    ],
    "[V][Ind][Intr][S_3Sg]": [
        "+'(g/t)uq"
    ],
    "[V][Ind][Trns][A_1Du][P_2Du]": [
        "+'(g)amegtek"
    ],
    "[V][Ind][Trns][A_1Du][P_2Pl]": [
        "+'(g)amegci"
    ],
    "[V][Ind][Trns][A_1Du][P_2Sg]": [
        "+'(g)amegten"
    ],
    "[V][Ind][Trns][A_1Du][P_3Du]": [
        "+'(g)agpuk"
    ],
    "[V][Ind][Trns][A_1Du][P_3Pl]": [
        "+'(g)apuk"
    ],
    "[V][Ind][Trns][A_1Du][P_3Sg]": [
        "+'(g)apuk",
        "+'(g)arpuk"
    ],
    "[V][Ind][Trns][A_1Pl][P_2Du]": [
        "+'(g)amcetek"
    ],
    "[V][Ind][Trns][A_1Pl][P_2Pl]": [
        "+'(g)amceci"
    ],
    "[V][Ind][Trns][A_1Pl][P_2Sg]": [
        "+'(g)amteggen"
    ],
    "[V][Ind][Trns][A_1Pl][P_3Du]": [
        "+'(g)agput"
    ],
    "[V][Ind][Trns][A_1Pl][P_3Pl]": [
        "+'(g)aput"
    ],
    "[V][Ind][Trns][A_1Pl][P_3Sg]": [
        "+'(g)aput",
        "+'(g)arput"
    ],
    "[V][Ind][Trns][A_1Sg][P_2Du]": [
        "+'(g)amtek"
    ],
    "[V][Ind][Trns][A_1Sg][P_2Pl]": [
        "+'(g)amci"
    ],
    "[V][Ind][Trns][A_1Sg][P_2Sg]": [
        "+'(g)amken"
    ],
    "[V][Ind][Trns][A_1Sg][P_3Du]": [
        "+'(g)agka"
    ],
    "[V][Ind][Trns][A_1Sg][P_3Pl]": [
        "+'(g)anka"
    ],
    "[V][Ind][Trns][A_1Sg][P_3Sg]": [
        "+'(g)aqa"
    ],
    "[V][Ind][Trns][A_2Du][P_1Du]": [
        "+'(g)avtegkuk",
        "+'(g)arpetegkuk"
    ],
    "[V][Ind][Trns][A_2Du][P_1Pl]": [
        "+'(g)avtegkut",
        "+'(g)arpetegkut"
    ],
    "[V][Ind][Trns][A_2Du][P_1Sg]": [
        "+'(g)avtegnenga",
        "+'(g)avtegnga",
        "+'(g)arpetegnenga",
        "+'(g)arpetegnga"
    ],
    "[V][Ind][Trns][A_2Du][P_3Du]": [
        "+'(g)agtek"
    ],
    "[V][Ind][Trns][A_2Du][P_3Pl]": [
        "+'(g)atek"
    ],
    "[V][Ind][Trns][A_2Du][P_3Sg]": [
        "+'(g)atek",
        "+'(g)artek"
    ],
    "[V][Ind][Trns][A_2Pl][P_1Du]": [
        "+'(g)avcikuk",
        "+'(g)arpecikuk"
    ],
    "[V][Ind][Trns][A_2Pl][P_1Pl]": [
        "+'(g)avcikut",
        "+'(g)arpecikut"
    ],
    "[V][Ind][Trns][A_2Pl][P_1Sg]": [
        "+'(g)avcia",
        "+'(g)arpecia"
    ],
    "[V][Ind][Trns][A_2Pl][P_3Du]": [
        "+'(g)agci"
    ],
    "[V][Ind][Trns][A_2Pl][P_3Pl]": [
        "+'(g)aci"
    ],
    "[V][Ind][Trns][A_2Pl][P_3Sg]": [
        "+'(g)aci",
        "+'(g)arci"
    ],
    "[V][Ind][Trns][A_2Sg][P_1Du]": [
        "+'(g)avkuk",
        "+'(g)arpekuk"
    ],
    "[V][Ind][Trns][A_2Sg][P_1Pl]": [
        "+'(g)avkut",
        "+'(g)arpekut"
    ],
    "[V][Ind][Trns][A_2Sg][P_1Sg]": [
        "+'(g)avnga",
        "+'(g)arpenga"
    ],
    "[V][Ind][Trns][A_2Sg][P_3Du]": [
        "+'(g)agken"
    ],
    "[V][Ind][Trns][A_2Sg][P_3Pl]": [
        "+'(g)aten"
    ],
    "[V][Ind][Trns][A_2Sg][P_3Sg]": [
        "+'(g)an"
    ],
    "[V][Ind][Trns][A_3Du][P_1Du]": [
        "+'(g)aagkuk"
    ],
    "[V][Ind][Trns][A_3Du][P_1Pl]": [
        "+'(g)aagkut"
    ],
    "[V][Ind][Trns][A_3Du][P_1Sg]": [
        "+'(g)aagnenga",
        "+'(g)aagnga"
    ],
    "[V][Ind][Trns][A_3Du][P_2Du]": [
        "+'(g)aagtek"
    ],
    "[V][Ind][Trns][A_3Du][P_2Pl]": [
        "+'(g)aagci"
    ],
    "[V][Ind][Trns][A_3Du][P_2Sg]": [
        "+'(g)aagten"
    ],
    "[V][Ind][Trns][A_3Du][P_3Du]": [
        "+'(g)agkek"
    ],
    "[V][Ind][Trns][A_3Du][P_3Pl]": [
        "+'(g)akek"
    ],
    "[V][Ind][Trns][A_3Du][P_3Sg]": [
        "+'(g)aak"
    ],
    "[V][Ind][Trns][A_3Pl][P_1Du]": [
        "+'(g)aitkuk"
    ],
    "[V][Ind][Trns][A_3Pl][P_1Pl]": [
        "+'(g)aitkut"
    ],
    "[V][Ind][Trns][A_3Pl][P_1Sg]": [
        "+'(g)aatnga"
    ],
    "[V][Ind][Trns][A_3Pl][P_2Du]": [
        "+'(g)aicetek"
    ],
    "[V][Ind][Trns][A_3Pl][P_2Pl]": [
        "+'(g)aiceci"
    ],
    "[V][Ind][Trns][A_3Pl][P_2Sg]": [
        "+'(g)aatgen"
    ],
    "[V][Ind][Trns][A_3Pl][P_3Du]": [
        "+'(g)agket"
    ],
    "[V][Ind][Trns][A_3Pl][P_3Pl]": [
        "+'(g)ait"
    ],
    "[V][Ind][Trns][A_3Pl][P_3Sg]": [
        "+'(g)aat"
    ],
    "[V][Ind][Trns][A_3Sg][P_1Du]": [
        "+'(g)aakuk"
    ],
    "[V][Ind][Trns][A_3Sg][P_1Pl]": [
        "+'(g)aakut"
    ],
    "[V][Ind][Trns][A_3Sg][P_1Sg]": [
        "+'(g)aanga"
    ],
    "[V][Ind][Trns][A_3Sg][P_2Du]": [
        "+'(g)aatek"
    ],
    "[V][Ind][Trns][A_3Sg][P_2Pl]": [
        "+'(g)aaci"
    ],
    "[V][Ind][Trns][A_3Sg][P_2Sg]": [
        "+'(g)aaten"
    ],
    "[V][Ind][Trns][A_3Sg][P_3Du]": [
        "+'(g)ak"
    ],
    "[V][Ind][Trns][A_3Sg][P_3Pl]": [
        "+'(g)ai"
    ],
    "[V][Ind][Trns][A_3Sg][P_3Sg]": [
        "+'(g)aa"
    ],
    "[V][Intrg][Intr][S_1Du]": [
        "@~+cen̄uk",
        "@~+cen̄ung"
    ],
    "[V][Intrg][Intr][S_1Pl]": [
        "@~+ceta"
    ],
    "[V][Intrg][Intr][S_1Sg]": [
        "~+(t)sia",
        "~+(t)yia"
    ],
    "[V][Intrg][Intr][S_2Du]": [
        "@~+cetek"
    ],
    "[V][Intrg][Intr][S_2Pl]": [
        "@~+ceci",
        "+(s)tessi"
    ],
    "[V][Intrg][Intr][S_2Sg]": [
        "~+(t)sit",
        "~+(t)yit"
    ],
    "[V][Intrg][Intr][S_3Du]": [
        "+'(g/t)ak"
    ],
    "[V][Intrg][Intr][S_3Pl]": [
        "+'(g/t)at"
    ],
    "[V][Intrg][Intr][S_3Sg]": [
        "+'(g/t)a"
    ],
    "[V][Intrg][Trns][A_1Sg][P_2Sg]": [
        "~+(t)siken",
        "~+(t)yiken"
    ],
    "[V][Intrg][Trns][A_2Du][P_1Du]": [
        "@~+cetegkuk"
    ],
    "[V][Intrg][Trns][A_2Du][P_1Pl]": [
        "@~+cetegkut"
    ],
    "[V][Intrg][Trns][A_2Du][P_1Sg]": [
        "@~+cetegnga"
    ],
    "[V][Intrg][Trns][A_2Du][P_3Du]": [
        "@~+cetegkek"
    ],
    "[V][Intrg][Trns][A_2Du][P_3Pl]": [
        "@~+cetegki"
    ],
    "[V][Intrg][Trns][A_2Du][P_3Sg]": [
        "@~+cetegnegu"
    ],
    "[V][Intrg][Trns][A_2Pl][P_1Du]": [
        "@~+cecikuk"
    ],
    "[V][Intrg][Trns][A_2Pl][P_1Pl]": [
        "@~+cecikut"
    ],
    "[V][Intrg][Trns][A_2Pl][P_1Sg]": [
        "@~+cecia"
    ],
    "[V][Intrg][Trns][A_2Pl][P_3Du]": [
        "@~+cecikek"
    ],
    "[V][Intrg][Trns][A_2Pl][P_3Pl]": [
        "@~+ceciki"
    ],
    "[V][Intrg][Trns][A_2Pl][P_3Sg]": [
        "@~+ceciu"
    ],
    "[V][Intrg][Trns][A_2Sg][P_1Du]": [
        "~+(t)sikuk",
        "~+(t)yikuk"
    ],
    "[V][Intrg][Trns][A_2Sg][P_1Pl]": [
        "~+(t)sikut",
        "~+(t)yikut"
    ],
    "[V][Intrg][Trns][A_2Sg][P_1Sg]": [
        "~+(t)sia",
        "~+(t)yia"
    ],
    "[V][Intrg][Trns][A_2Sg][P_3Du]": [
        "~+(t)sikek",
        "~+(t)yikek"
    ],
    "[V][Intrg][Trns][A_2Sg][P_3Pl]": [
        "~+(t)siki",
        "~+(t)yiki"
    ],
    "[V][Intrg][Trns][A_2Sg][P_3Sg]": [
        "~+(t)siu",
        "~+(t)yiu"
    ],
    "[V][Intrg][Trns][A_3Du][P_1Du]": [
        "+'(g/t)agkuk",
        "+'(g/t)agnekuk"
    ],
    "[V][Intrg][Trns][A_3Du][P_1Pl]": [
        "+'(g/t)agkut",
        "+'(g/t)agnekut"
    ],
    "[V][Intrg][Trns][A_3Du][P_1Sg]": [
        "+'(g/t)agnenga",
        "+'(g/t)agnga"
    ],
    "[V][Intrg][Trns][A_3Du][P_2Du]": [
        "+'(g/t)agtek",
        "+'(g/t)agnetek"
    ],
    "[V][Intrg][Trns][A_3Du][P_2Pl]": [
        "+'(g/t)agneci",
        "+'(g/t)agci"
    ],
    "[V][Intrg][Trns][A_3Du][P_2Sg]": [
        "+'(g/t)agten",
        "+'(g/t)agneten"
    ],
    "[V][Intrg][Trns][A_3Du][P_3Du]": [
        "+'(g/t)agkek",
        "+'(g/t)agnekek"
    ],
    "[V][Intrg][Trns][A_3Du][P_3Pl]": [
        "+'(g/t)agki",
        "+'(g/t)agneki"
    ],
    "[V][Intrg][Trns][A_3Du][P_3Sg]": [
        "+'(g/t)agnegu",
        "+'(g/t)anʼgu"
    ],
    "[V][Intrg][Trns][A_3Pl][P_1Du]": [
        "+'(g/t)atkuk"
    ],
    "[V][Intrg][Trns][A_3Pl][P_1Pl]": [
        "+'(g/t)atkut"
    ],
    "[V][Intrg][Trns][A_3Pl][P_1Sg]": [
        "+'(g/t)atnga"
    ],
    "[V][Intrg][Trns][A_3Pl][P_2Du]": [
        "+'(g/t)acetek"
    ],
    "[V][Intrg][Trns][A_3Pl][P_2Pl]": [
        "+'(g/t)aceci"
    ],
    "[V][Intrg][Trns][A_3Pl][P_2Sg]": [
        "+'(g/t)atgen"
    ],
    "[V][Intrg][Trns][A_3Pl][P_3Du]": [
        "+'(g/t)atkek"
    ],
    "[V][Intrg][Trns][A_3Pl][P_3Pl]": [
        "+'(g/t)atki"
    ],
    "[V][Intrg][Trns][A_3Pl][P_3Sg]": [
        "+'(g/t)atgu"
    ],
    "[V][Intrg][Trns][A_3Sg][P_1Du]": [
        "+'(g/t)akuk"
    ],
    "[V][Intrg][Trns][A_3Sg][P_1Pl]": [
        "+'(g/t)akut"
    ],
    "[V][Intrg][Trns][A_3Sg][P_1Sg]": [
        "+'(g/t)anga"
    ],
    "[V][Intrg][Trns][A_3Sg][P_2Du]": [
        "+'(g/t)atek"
    ],
    "[V][Intrg][Trns][A_3Sg][P_2Pl]": [
        "+'(g/t)aci"
    ],
    "[V][Intrg][Trns][A_3Sg][P_2Sg]": [
        "+'(g/t)aten"
    ],
    "[V][Intrg][Trns][A_3Sg][P_3Du]": [
        "+'(g/t)akek"
    ],
    "[V][Intrg][Trns][A_3Sg][P_3Pl]": [
        "+'(g/t)aki"
    ],
    "[V][Intrg][Trns][A_3Sg][P_3Sg]": [
        "+'(g/t)a:gu"
    ],
    "[V][Opt][Intr][FUT][NEG][S_2Du]": [
        "@~+yaqunatek"
    ],
    "[V][Opt][Intr][FUT][NEG][S_2Pl]": [
        "@~+yaqunaci"
    ],
    "[V][Opt][Intr][FUT][NEG][S_2Sg]": [
        "@~+yaqunak"
    ],
    "[V][Opt][Intr][FUT][S_1Du]": [
        "@~–kiluk"
    ],
    "[V][Opt][Intr][FUT][S_1Pl]": [
        "@~–kilta"
    ],
    "[V][Opt][Intr][FUT][S_1Sg]": [
        "@~–kilii"
    ],
    "[V][Opt][Intr][FUT][S_2Du]": [
        "@~–kitek"
    ],
    "[V][Opt][Intr][FUT][S_2Pl]": [
        "@~–kici"
    ],
    "[V][Opt][Intr][FUT][S_2Sg]": [
        "@~–kina"
    ],
    "[V][Opt][Intr][FUT][S_3Du]": [
        "@~–kilik"
    ],
    "[V][Opt][Intr][FUT][S_3Pl]": [
        "@~–kilit"
    ],
    "[V][Opt][Intr][FUT][S_3Sg]": [
        "@~–kili"
    ],
    "[V][Opt][Intr][PRS][NEG][S_2Du]": [
        "~viiqnatek",
        "@+piiqnatek"
    ],
    "[V][Opt][Intr][PRS][NEG][S_2Pl]": [
        "~viiqnaci",
        "@+piiqnaci"
    ],
    "[V][Opt][Intr][PRS][NEG][S_2Sg]": [
        "~viiqnak",
        "@+piiqnak"
    ],
    "[V][Opt][Intr][PRS][S_1Du]": [
        "@~+luk"
    ],
    "[V][Opt][Intr][PRS][S_1Pl]": [
        "%:(e)lta",
        "–lta"
    ],
    "[V][Opt][Intr][PRS][S_1Sg]": [
        "@~+lii"
    ],
    "[V][Opt][Intr][PRS][S_2Du]": [
        "@+tek",
        "~(g)itek"
    ],
    "[V][Opt][Intr][PRS][S_2Pl]": [
        "@+ci",
        "~(g)ici"
    ],
    "[V][Opt][Intr][PRS][S_2Sg]": [
        ":a",
        "@lu",
        "",
        "~(g)i",
        "+n"
    ],
    "[V][Opt][Intr][PRS][S_3Du]": [
        "@~+lik"
    ],
    "[V][Opt][Intr][PRS][S_3Pl]": [
        "@~+lit"
    ],
    "[V][Opt][Intr][PRS][S_3Sg]": [
        "@~+li"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_2Du]": [
        "@~–kilamegtek"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_2Pl]": [
        "@~–kilamegci"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_2Sg]": [
        "@~–kilamegten"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_3Du]": [
        "@~–kilagpuk"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_3Pl]": [
        "@~–kilapuk"
    ],
    "[V][Opt][Trns][FUT][A_1Du][P_3Sg]": [
        "@~–kilauk"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_2Du]": [
        "@~–kilamcetek"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_2Pl]": [
        "@~–kilamceci"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_2Sg]": [
        "@~–kilamteggen"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_3Du]": [
        "@~–kilagput"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_3Pl]": [
        "@~–kilaput"
    ],
    "[V][Opt][Trns][FUT][A_1Pl][P_3Sg]": [
        "@~–kilaut"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_2Du]": [
        "@~–kilamtek"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_2Pl]": [
        "@~–kilamci"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_2Sg]": [
        "@~–kilaken",
        "@~–kilamken"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_3Du]": [
        "@~–kilakek"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_3Pl]": [
        "@~–kilaki"
    ],
    "[V][Opt][Trns][FUT][A_1Sg][P_3Sg]": [
        "@~–kilaku"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_1Du]": [
        "@~–kitegkuk"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_1Pl]": [
        "@~–kitegkut"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_1Sg]": [
        "@~–kitegnga"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_3Du]": [
        "@~–kitegkek"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_3Pl]": [
        "@~–kitegki"
    ],
    "[V][Opt][Trns][FUT][A_2Du][P_3Sg]": [
        "@~–kitegu"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_1Du]": [
        "@~–kicikuk"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_1Pl]": [
        "@~–kicikut"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_1Sg]": [
        "@~–kicia"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_3Du]": [
        "@~–kicikek"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_3Pl]": [
        "@~–kiciki"
    ],
    "[V][Opt][Trns][FUT][A_2Pl][P_3Sg]": [
        "@~–kiciu"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_1Du]": [
        "@~–kikuk"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_1Pl]": [
        "@~–kikut"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_1Sg]": [
        "@~–kia"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_3Du]": [
        "@~–kikek"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_3Pl]": [
        "@~–kiki"
    ],
    "[V][Opt][Trns][FUT][A_2Sg][P_3Sg]": [
        "@~–kiu"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_1Du]": [
        "@~–kiligkuk",
        "@~–kilignekuk"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_1Pl]": [
        "@~–kiligkut",
        "@~–kilignekut"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_1Sg]": [
        "@~–kilignenga",
        "@~–kilignga"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_2Du]": [
        "@~–kiligtek",
        "@~–kilignetek"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_2Pl]": [
        "@~–kiligneci",
        "@~–kiligci"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_2Sg]": [
        "@~–kiligten",
        "@~–kiligneten"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_3Du]": [
        "@~–kiligkek",
        "@~–kilignekek"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_3Pl]": [
        "@~–kiligki",
        "@~–kiligneki"
    ],
    "[V][Opt][Trns][FUT][A_3Du][P_3Sg]": [
        "@~–kilignegu",
        "@~–kilinʼgu"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_1Du]": [
        "@~–kilitkuk"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_1Pl]": [
        "@~–kilitkut"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_1Sg]": [
        "@~–kilitnga"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_2Du]": [
        "@~–kilicetek"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_2Pl]": [
        "@~–kiliceci"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_2Sg]": [
        "@~–kilitgen"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_3Du]": [
        "@~–kilitkek"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_3Pl]": [
        "@~–kilitki"
    ],
    "[V][Opt][Trns][FUT][A_3Pl][P_3Sg]": [
        "@~–kilitgu"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_1Du]": [
        "@~–kilikuk"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_1Pl]": [
        "@~–kilikut"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_1Sg]": [
        "@~–kilinga"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_2Du]": [
        "@~–kilitek"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_2Pl]": [
        "@~–kilici"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_2Sg]": [
        "@~–kiliten"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_3Du]": [
        "@~–kilikek"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_3Pl]": [
        "@~–kiliki"
    ],
    "[V][Opt][Trns][FUT][A_3Sg][P_3Sg]": [
        "@~–kiliu"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_1Du]": [
        "@~+yaqunategkuk"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_1Pl]": [
        "@~+yaqunategkut"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_1Sg]": [
        "@~+yaqunategnga"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_3Du]": [
        "@~+yaqunategkek"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_3Pl]": [
        "@~+yaqunategki"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Du][P_3Sg]": [
        "@~+yaqunategu"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Du]": [
        "@~+yaqunacikuk"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Pl]": [
        "@~+yaqunacikut"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_1Sg]": [
        "@~+yaqunacia"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Du]": [
        "@~+yaqunacikek"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Pl]": [
        "@~+yaqunaciki"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Pl][P_3Sg]": [
        "@~+yaqunaciu"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Du]": [
        "@~+yaqunakuk"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Pl]": [
        "@~+yaqunakut"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_1Sg]": [
        "@~+yaquna:nga"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Du]": [
        "@~+yaqunakek"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Pl]": [
        "@~+yaqunaki"
    ],
    "[V][Opt][Trns][FUT][NEG][A_2Sg][P_3Sg]": [
        "@~+yaqunaku"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_2Du]": [
        "@~+lamegtek"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_2Pl]": [
        "@~+lamegci"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_2Sg]": [
        "@~+lamegten"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_3Du]": [
        "@~+lagpuk"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_3Pl]": [
        "@~+lapuk"
    ],
    "[V][Opt][Trns][PRS][A_1Du][P_3Sg]": [
        "@~+lauk"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_2Du]": [
        "@~+lamcetek"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_2Pl]": [
        "@~+lamceci"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_2Sg]": [
        "@~+lamteggen"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_3Du]": [
        "@~+lagput"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_3Pl]": [
        "@~+laput"
    ],
    "[V][Opt][Trns][PRS][A_1Pl][P_3Sg]": [
        "@~+laut"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_2Du]": [
        "@~+lamtek"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_2Pl]": [
        "@~+lamci"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_2Sg]": [
        "@~+laken",
        "@~+lamken"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_3Du]": [
        "@~+lakek"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_3Pl]": [
        "@~+laki"
    ],
    "[V][Opt][Trns][PRS][A_1Sg][P_3Sg]": [
        "@~+laku"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_1Du]": [
        "@+tegkuk"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_1Pl]": [
        "@+tegkut"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_1Sg]": [
        "@+tegnga"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_3Du]": [
        "@+tegkek"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_3Pl]": [
        "@+tegki"
    ],
    "[V][Opt][Trns][PRS][A_2Du][P_3Sg]": [
        "@+tegu"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_1Du]": [
        "@+cikuk"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_1Pl]": [
        "@+cikut"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_1Sg]": [
        "@+cia"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_3Du]": [
        "@+cikek"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_3Pl]": [
        "@+ciki"
    ],
    "[V][Opt][Trns][PRS][A_2Pl][P_3Sg]": [
        "@+ciu"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_1Du]": [
        "@+kuk",
        "~(g)ikuk"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_1Pl]": [
        "@+kut",
        "~(g)ikut"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_1Sg]": [
        "~(g)ia",
        "@+nga"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_3Du]": [
        "@+kek",
        "~(g)ikek"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_3Pl]": [
        "@+ki",
        "~(g)iki"
    ],
    "[V][Opt][Trns][PRS][A_2Sg][P_3Sg]": [
        "@gu",
        "u",
        "~(g)iu"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_1Du]": [
        "@~+ligkuk",
        "@~+lignekuk"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_1Pl]": [
        "@~+ligkut",
        "@~+lignekut"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_1Sg]": [
        "@~+lignenga",
        "@~+lignga"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_2Du]": [
        "@~+ligtek",
        "@~+lignetek"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_2Pl]": [
        "@~+ligneci",
        "@~+ligci"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_2Sg]": [
        "@~+ligten",
        "@~+ligneten"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_3Du]": [
        "@~+ligkek",
        "@~+lignekek"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_3Pl]": [
        "@~+ligki",
        "@~+ligneki"
    ],
    "[V][Opt][Trns][PRS][A_3Du][P_3Sg]": [
        "@~+lignegu",
        "@~linʼgu"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_1Du]": [
        "@~+litkuk"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_1Pl]": [
        "@~+litkut"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_1Sg]": [
        "@~+litnga"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_2Du]": [
        "@~+licetek"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_2Pl]": [
        "@~+liceci"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_2Sg]": [
        "@~+litgen"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_3Du]": [
        "@~+litkek"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_3Pl]": [
        "@~+litki"
    ],
    "[V][Opt][Trns][PRS][A_3Pl][P_3Sg]": [
        "@~+litgu"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_1Du]": [
        "@~+likuk"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_1Pl]": [
        "@~+likut"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_1Sg]": [
        "@~+lia",
        "@~+linga"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_2Du]": [
        "@~+litek"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_2Pl]": [
        "@~+lici"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_2Sg]": [
        "@~+liten"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_3Du]": [
        "@~+likek"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_3Pl]": [
        "@~+liki"
    ],
    "[V][Opt][Trns][PRS][A_3Sg][P_3Sg]": [
        "@~+liku",
        "@~+liu"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_1Du]": [
        "~viiqnategkuk",
        "@+piiqnategkuk"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_1Pl]": [
        "~viiqnategkut",
        "@+piiqnategkut"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_1Sg]": [
        "~viiqnategnga",
        "@+piiqnategnga"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_3Du]": [
        "~viiqnategkek",
        "@+piiqnategkek"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_3Pl]": [
        "~viiqnategki",
        "@+piiqnategki"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Du][P_3Sg]": [
        "~viiqnategu",
        "@+piiqnategu"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Du]": [
        "~viiqnacikuk",
        "@+piiqnacikuk"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Pl]": [
        "~viiqnacikut",
        "@+piiqnacikut"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_1Sg]": [
        "~viiqnacia",
        "@+piiqnacia"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Du]": [
        "~viiqnacikek",
        "@+piiqnacikek"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Pl]": [
        "~viiqnaciki",
        "@+piiqnaciki"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Pl][P_3Sg]": [
        "~viiqnaciu",
        "@+piiqnaciu"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Du]": [
        "~viiqnakuk",
        "@+piiqnakuk"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Pl]": [
        "~viiqnakut",
        "@+piiqnakut"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_1Sg]": [
        "~viiqna:nga",
        "@+piiqna:nga"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Du]": [
        "~viiqnakek",
        "@+piiqnakek"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Pl]": [
        "~viiqnaki",
        "@+piiqnaki"
    ],
    "[V][Opt][Trns][PRS][NEG][A_2Sg][P_3Sg]": [
        "~viiqnaku",
        "@+piiqnaku"
    ],
    "[V][Prec][Intr][S_1Du]": [
        "~vaileg–megnuk",
        "@+paileg–megnuk"
    ],
    "[V][Prec][Intr][S_1Pl]": [
        "~vaileg–mta",
        "@+paileg–mta"
    ],
    "[V][Prec][Intr][S_1Sg]": [
        "~vaileg+ma",
        "@+paileg+ma"
    ],
    "[V][Prec][Intr][S_2Du]": [
        "~vaileg+petek",
        "@+paileg+petek"
    ],
    "[V][Prec][Intr][S_2Pl]": [
        "~vaileg+peci",
        "@+paileg+peci"
    ],
    "[V][Prec][Intr][S_2Sg]": [
        "~vaileg+pet",
        "@+paileg+pet"
    ],
    "[V][Prec][Intr][S_3Du]": [
        "~vaileg:agnek",
        "@+paileg:agnek"
    ],
    "[V][Prec][Intr][S_3Pl]": [
        "~vaileg:ata",
        "@+paileg:ata"
    ],
    "[V][Prec][Intr][S_3Sg]": [
        "~vaileg:an",
        "@+paileg:an"
    ],
    "[V][Prec][Intr][S_4Du]": [
        "~vaileg+mek",
        "@+paileg+mek"
    ],
    "[V][Prec][Intr][S_4Pl]": [
        "~vaileg+meng",
        "@+paileg+meng"
    ],
    "[V][Prec][Intr][S_4Sg]": [
        "~vaileg+mi",
        "@+paileg+mi"
    ],
    "[V][Prec][Trns][A_1Du][P_2Du]": [
        "~vaileg–megtek",
        "@+paileg–megtek"
    ],
    "[V][Prec][Trns][A_1Du][P_2Pl]": [
        "~vaileg–megci",
        "@+paileg–megci"
    ],
    "[V][Prec][Trns][A_1Du][P_2Sg]": [
        "~vaileg–megten",
        "@+paileg–megten"
    ],
    "[V][Prec][Trns][A_1Du][P_3Du]": [
        "~vaileg–megkek",
        "@+paileg–megkek"
    ],
    "[V][Prec][Trns][A_1Du][P_3Pl]": [
        "~vaileg–megki",
        "@+paileg–megki"
    ],
    "[V][Prec][Trns][A_1Du][P_3Sg]": [
        "~vaileg–megnegu",
        "@+paileg–megnegu"
    ],
    "[V][Prec][Trns][A_1Du][P_4Du]": [
        "~vaileg–megtek",
        "@+paileg–megtek"
    ],
    "[V][Prec][Trns][A_1Du][P_4Pl]": [
        "~vaileg–megteng",
        "@+paileg–megteng"
    ],
    "[V][Prec][Trns][A_1Du][P_4Sg]": [
        "~vaileg–megni",
        "@+paileg–megni"
    ],
    "[V][Prec][Trns][A_1Pl][P_2Du]": [
        "~vaileg–mcetek",
        "@+paileg–mcetek"
    ],
    "[V][Prec][Trns][A_1Pl][P_2Pl]": [
        "~vaileg–mceci",
        "@+paileg–mceci"
    ],
    "[V][Prec][Trns][A_1Pl][P_2Sg]": [
        "~vaileg–mteggen",
        "@+paileg–mteggen"
    ],
    "[V][Prec][Trns][A_1Pl][P_3Du]": [
        "~vaileg–mtekek",
        "@+paileg–mtekek"
    ],
    "[V][Prec][Trns][A_1Pl][P_3Pl]": [
        "~vaileg–mteki",
        "@+paileg–mteki"
    ],
    "[V][Prec][Trns][A_1Pl][P_3Sg]": [
        "~vaileg–mteggu",
        "@+paileg–mteggu"
    ],
    "[V][Prec][Trns][A_1Pl][P_4Du]": [
        "~vaileg–mcetek",
        "@+paileg–mcetek"
    ],
    "[V][Prec][Trns][A_1Pl][P_4Pl]": [
        "~vaileg–mceteng",
        "@+paileg–mceteng"
    ],
    "[V][Prec][Trns][A_1Pl][P_4Sg]": [
        "~vaileg–mten̄i",
        "@+paileg–mten̄i"
    ],
    "[V][Prec][Trns][A_1Sg][P_2Du]": [
        "~vaileg–mtek",
        "@+paileg–mtek"
    ],
    "[V][Prec][Trns][A_1Sg][P_2Pl]": [
        "~vaileg–mci",
        "@+paileg–mci"
    ],
    "[V][Prec][Trns][A_1Sg][P_2Sg]": [
        "~vaileg–mken",
        "@+paileg–mken"
    ],
    "[V][Prec][Trns][A_1Sg][P_3Du]": [
        "~vaileg–mkek",
        "@+paileg–mkek"
    ],
    "[V][Prec][Trns][A_1Sg][P_3Pl]": [
        "~vaileg–mki",
        "@+paileg–mki"
    ],
    "[V][Prec][Trns][A_1Sg][P_3Sg]": [
        "~vaileg–mku",
        "@+paileg–mku"
    ],
    "[V][Prec][Trns][A_1Sg][P_4Du]": [
        "~vaileg–mtek",
        "@+paileg–mtek"
    ],
    "[V][Prec][Trns][A_1Sg][P_4Pl]": [
        "~vaileg–mteng",
        "@+paileg–mteng"
    ],
    "[V][Prec][Trns][A_1Sg][P_4Sg]": [
        "~vaileg–mni",
        "@+paileg–mni"
    ],
    "[V][Prec][Trns][A_2Du][P_1Du]": [
        "~vaileg+petegkuk",
        "@+paileg+petegkuk"
    ],
    "[V][Prec][Trns][A_2Du][P_1Pl]": [
        "~vaileg+petegkut",
        "@+paileg+petegkut"
    ],
    "[V][Prec][Trns][A_2Du][P_1Sg]": [
        "~vaileg+petegnga",
        "@+paileg+petegnga"
    ],
    "[V][Prec][Trns][A_2Du][P_3Du]": [
        "~vaileg+petegkek",
        "@+paileg+petegkek"
    ],
    "[V][Prec][Trns][A_2Du][P_3Pl]": [
        "~vaileg+petegki",
        "@+paileg+petegki"
    ],
    "[V][Prec][Trns][A_2Du][P_3Sg]": [
        "~vaileg+petegnegu",
        "@+paileg+petegnegu"
    ],
    "[V][Prec][Trns][A_2Du][P_4Du]": [
        "~vaileg+petegtek",
        "@+paileg+petegtek"
    ],
    "[V][Prec][Trns][A_2Du][P_4Pl]": [
        "~vaileg+petegteng",
        "@+paileg+petegteng"
    ],
    "[V][Prec][Trns][A_2Du][P_4Sg]": [
        "~vaileg+petegni",
        "@+paileg+petegni"
    ],
    "[V][Prec][Trns][A_2Pl][P_1Du]": [
        "~vaileg+pecikuk",
        "@+paileg+pecikuk"
    ],
    "[V][Prec][Trns][A_2Pl][P_1Pl]": [
        "~vaileg+pecikut",
        "@+paileg+pecikut"
    ],
    "[V][Prec][Trns][A_2Pl][P_1Sg]": [
        "~vaileg+pecia",
        "@+paileg+pecia"
    ],
    "[V][Prec][Trns][A_2Pl][P_3Du]": [
        "~vaileg+pecikek",
        "@+paileg+pecikek"
    ],
    "[V][Prec][Trns][A_2Pl][P_3Pl]": [
        "~vaileg+peciki",
        "@+paileg+peciki"
    ],
    "[V][Prec][Trns][A_2Pl][P_3Sg]": [
        "~vaileg+peciu",
        "@+paileg+peciu"
    ],
    "[V][Prec][Trns][A_2Pl][P_4Du]": [
        "~vaileg+pecitek",
        "@+paileg+pecitek"
    ],
    "[V][Prec][Trns][A_2Pl][P_4Pl]": [
        "~vaileg+peciteng",
        "@+paileg+peciteng"
    ],
    "[V][Prec][Trns][A_2Pl][P_4Sg]": [
        "~vaileg+pecini",
        "@+paileg+pecini"
    ],
    "[V][Prec][Trns][A_2Sg][P_1Du]": [
        "~vaileg+pekuk",
        "@+paileg+pekuk"
    ],
    "[V][Prec][Trns][A_2Sg][P_1Pl]": [
        "~vaileg+pekut",
        "@+paileg+pekut"
    ],
    "[V][Prec][Trns][A_2Sg][P_1Sg]": [
        "~vaileg+penga",
        "@+paileg+penga"
    ],
    "[V][Prec][Trns][A_2Sg][P_3Du]": [
        "~vaileg+pekek",
        "@+paileg+pekek"
    ],
    "[V][Prec][Trns][A_2Sg][P_3Pl]": [
        "~vaileg+peki",
        "@+paileg+peki"
    ],
    "[V][Prec][Trns][A_2Sg][P_3Sg]": [
        "~vaileg+pegu",
        "@+paileg+pegu"
    ],
    "[V][Prec][Trns][A_2Sg][P_4Du]": [
        "~vaileg+petek",
        "@+paileg+petek"
    ],
    "[V][Prec][Trns][A_2Sg][P_4Pl]": [
        "~vaileg+peteng",
        "@+paileg+peteng"
    ],
    "[V][Prec][Trns][A_2Sg][P_4Sg]": [
        "~vaileg+peni",
        "@+paileg+peni"
    ],
    "[V][Prec][Trns][A_3Du][P_1Du]": [
        "~vaileg:agkuk",
        "@+paileg:agkuk"
    ],
    "[V][Prec][Trns][A_3Du][P_1Pl]": [
        "~vaileg:agkut",
        "@+paileg:agkut"
    ],
    "[V][Prec][Trns][A_3Du][P_1Sg]": [
        "~vaileg:agnga",
        "@+paileg:agnga"
    ],
    "[V][Prec][Trns][A_3Du][P_2Du]": [
        "~vaileg:agtek",
        "@+paileg:agtek"
    ],
    "[V][Prec][Trns][A_3Du][P_2Pl]": [
        "~vaileg:agci",
        "@+paileg:agci"
    ],
    "[V][Prec][Trns][A_3Du][P_2Sg]": [
        "~vaileg:agten",
        "@+paileg:agten"
    ],
    "[V][Prec][Trns][A_3Du][P_3Du]": [
        "~vaileg:agkek",
        "@+paileg:agkek"
    ],
    "[V][Prec][Trns][A_3Du][P_3Pl]": [
        "~vaileg:agki",
        "@+paileg:agki"
    ],
    "[V][Prec][Trns][A_3Du][P_3Sg]": [
        "~vaileg:agnegu",
        "@+paileg:agnegu"
    ],
    "[V][Prec][Trns][A_3Du][P_4Du]": [
        "~vaileg:agtek",
        "@+paileg:agtek"
    ],
    "[V][Prec][Trns][A_3Du][P_4Pl]": [
        "~vaileg:agteng",
        "@+paileg:agteng"
    ],
    "[V][Prec][Trns][A_3Du][P_4Sg]": [
        "~vaileg:agni",
        "@+paileg:agni"
    ],
    "[V][Prec][Trns][A_3Pl][P_1Du]": [
        "~vaileg:atkuk",
        "@+paileg:atkuk"
    ],
    "[V][Prec][Trns][A_3Pl][P_1Pl]": [
        "~vaileg:atkut",
        "@+paileg:atkut"
    ],
    "[V][Prec][Trns][A_3Pl][P_1Sg]": [
        "~vaileg:atnga",
        "@+paileg:atnga"
    ],
    "[V][Prec][Trns][A_3Pl][P_2Du]": [
        "~vaileg:acetek",
        "@+paileg:acetek"
    ],
    "[V][Prec][Trns][A_3Pl][P_2Pl]": [
        "~vaileg:aceci",
        "@+paileg:aceci"
    ],
    "[V][Prec][Trns][A_3Pl][P_2Sg]": [
        "~vaileg:atgen",
        "@+paileg:atgen"
    ],
    "[V][Prec][Trns][A_3Pl][P_3Du]": [
        "~vaileg:atkek",
        "@+paileg:atkek"
    ],
    "[V][Prec][Trns][A_3Pl][P_3Pl]": [
        "~vaileg:atki",
        "@+paileg:atki"
    ],
    "[V][Prec][Trns][A_3Pl][P_3Sg]": [
        "~vaileg:atgu",
        "@+paileg:atgu"
    ],
    "[V][Prec][Trns][A_3Pl][P_4Du]": [
        "~vaileg:acetek",
        "@+paileg:acetek"
    ],
    "[V][Prec][Trns][A_3Pl][P_4Pl]": [
        "~vaileg:aceteng",
        "@+paileg:aceteng"
    ],
    "[V][Prec][Trns][A_3Pl][P_4Sg]": [
        "~vaileg:atni",
        "@+paileg:atni"
    ],
    "[V][Prec][Trns][A_3Sg][P_1Du]": [
        "~vaileg:akuk",
        "@+paileg:akuk"
    ],
    "[V][Prec][Trns][A_3Sg][P_1Pl]": [
        "~vaileg:akut",
        "@+paileg:akut"
    ],
    "[V][Prec][Trns][A_3Sg][P_1Sg]": [
        "~vaileg:anga",
        "@+paileg:anga"
    ],
    "[V][Prec][Trns][A_3Sg][P_2Du]": [
        "~vaileg:atek",
        "@+paileg:atek"
    ],
    "[V][Prec][Trns][A_3Sg][P_2Pl]": [
        "~vaileg:aci",
        "@+paileg:aci"
    ],
    "[V][Prec][Trns][A_3Sg][P_2Sg]": [
        "~vaileg:aten",
        "@+paileg:aten"
    ],
    "[V][Prec][Trns][A_3Sg][P_3Du]": [
        "~vaileg:akek",
        "@+paileg:akek"
    ],
    "[V][Prec][Trns][A_3Sg][P_3Pl]": [
        "~vaileg:aki",
        "@+paileg:aki"
    ],
    "[V][Prec][Trns][A_3Sg][P_3Sg]": [
        "~vaileg:aku",
        "@+paileg:aku"
    ],
    "[V][Prec][Trns][A_3Sg][P_4Du]": [
        "~vaileg:atek",
        "@+paileg:atek"
    ],
    "[V][Prec][Trns][A_3Sg][P_4Pl]": [
        "~vaileg:ateng",
        "@+paileg:ateng"
    ],
    "[V][Prec][Trns][A_3Sg][P_4Sg]": [
        "~vaileg:ani",
        "@+paileg:ani"
    ],
    "[V][Prec][Trns][A_4Du][P_1Du]": [
        "~vaileg+megnekuk",
        "@+paileg+megnekuk"
    ],
    "[V][Prec][Trns][A_4Du][P_1Pl]": [
        "~vaileg+megnekut",
        "@+paileg+megnekut"
    ],
    "[V][Prec][Trns][A_4Du][P_1Sg]": [
        "~vaileg+megnenga",
        "@+paileg+megnenga"
    ],
    "[V][Prec][Trns][A_4Du][P_2Du]": [
        "~vaileg+megnetek",
        "@+paileg+megnetek"
    ],
    "[V][Prec][Trns][A_4Du][P_2Pl]": [
        "~vaileg+megneci",
        "@+paileg+megneci"
    ],
    "[V][Prec][Trns][A_4Du][P_2Sg]": [
        "~vaileg+megnegen",
        "@+paileg+megnegen"
    ],
    "[V][Prec][Trns][A_4Du][P_3Du]": [
        "~vaileg+megnekek",
        "@+paileg+megnekek"
    ],
    "[V][Prec][Trns][A_4Du][P_3Pl]": [
        "~vaileg+megneki",
        "@+paileg+megneki"
    ],
    "[V][Prec][Trns][A_4Du][P_3Sg]": [
        "~vaileg+megnegu",
        "@+paileg+megnegu"
    ],
    "[V][Prec][Trns][A_4Pl][P_1Du]": [
        "~vaileg+megtekuk",
        "@+paileg+megtekuk"
    ],
    "[V][Prec][Trns][A_4Pl][P_1Pl]": [
        "~vaileg+megtekut",
        "@+paileg+megtekut"
    ],
    "[V][Prec][Trns][A_4Pl][P_1Sg]": [
        "~vaileg+megtenga",
        "@+paileg+megtenga"
    ],
    "[V][Prec][Trns][A_4Pl][P_2Du]": [
        "~vaileg+megcetek",
        "@+paileg+megcetek"
    ],
    "[V][Prec][Trns][A_4Pl][P_2Pl]": [
        "~vaileg+megceci",
        "@+paileg+megceci"
    ],
    "[V][Prec][Trns][A_4Pl][P_2Sg]": [
        "~vaileg+megteggen",
        "@+paileg+megteggen"
    ],
    "[V][Prec][Trns][A_4Pl][P_3Du]": [
        "~vaileg+megtekek",
        "@+paileg+megtekek"
    ],
    "[V][Prec][Trns][A_4Pl][P_3Pl]": [
        "~vaileg+megteki",
        "@+paileg+megteki"
    ],
    "[V][Prec][Trns][A_4Pl][P_3Sg]": [
        "~vaileg+megteggu",
        "@+paileg+megteggu"
    ],
    "[V][Prec][Trns][A_4Sg][P_1Du]": [
        "~vaileg+mikuk",
        "@+paileg+mikuk"
    ],
    "[V][Prec][Trns][A_4Sg][P_1Pl]": [
        "~vaileg+mikut",
        "@+paileg+mikut"
    ],
    "[V][Prec][Trns][A_4Sg][P_1Sg]": [
        "~vaileg+mia",
        "@+paileg+mia"
    ],
    "[V][Prec][Trns][A_4Sg][P_2Du]": [
        "~vaileg+mitek",
        "@+paileg+mitek"
    ],
    "[V][Prec][Trns][A_4Sg][P_2Pl]": [
        "~vaileg+mici",
        "@+paileg+mici"
    ],
    "[V][Prec][Trns][A_4Sg][P_2Sg]": [
        "~vaileg+miten",
        "@+paileg+miten"
    ],
    "[V][Prec][Trns][A_4Sg][P_3Du]": [
        "~vaileg+mikek",
        "@+paileg+mikek"
    ],
    "[V][Prec][Trns][A_4Sg][P_3Pl]": [
        "~vaileg+miki",
        "@+paileg+miki"
    ],
    "[V][Prec][Trns][A_4Sg][P_3Sg]": [
        "~vaileg+miu",
        "@+paileg+miu"
    ],
    "[V][Ptcp][Intr][S_1Du]": [
        "–lria–kuk",
        "–lrii–kuk",
        "@+ngur*–kuk"
    ],
    "[V][Ptcp][Intr][S_1Pl]": [
        "–lria–kut",
        "–lrii–kut",
        "@+ngur*–kut"
    ],
    "[V][Ptcp][Intr][S_1Sg]": [
        "–lria:(ng)a",
        "–lrii:(ng)a",
        "@+ngur*:(ng)a"
    ],
    "[V][Ptcp][Intr][S_2Du]": [
        "–lria–tek",
        "–lrii–tek",
        "@+ngur*–tek"
    ],
    "[V][Ptcp][Intr][S_2Pl]": [
        "–lria–si",
        "–lrii–si",
        "@+ngur*–si"
    ],
    "[V][Ptcp][Intr][S_2Sg]": [
        "–lria–ten",
        "–lrii–ten",
        "@+ngur*–ten"
    ],
    "[V][Ptcp][Intr][S_3Du]": [
        "–lria%:(e)k",
        "–lrii%:(e)k",
        "@+ngur*%:(e)k"
    ],
    "[V][Ptcp][Intr][S_3Pl]": [
        "–lria%:(e)t",
        "–lrii%:(e)t",
        "@+ngur*%:(e)t"
    ],
    "[V][Ptcp][Intr][S_3Sg]": [
        "–lria",
        "–lrii",
        "@+ngur*"
    ],
    "[V][Ptcp][Trns][A_1Du][P_2Du]": [
        "@~–kemegtek"
    ],
    "[V][Ptcp][Trns][A_1Du][P_2Pl]": [
        "@~–kemegci"
    ],
    "[V][Ptcp][Trns][A_1Du][P_2Sg]": [
        "@~–kemegten"
    ],
    "[V][Ptcp][Trns][A_1Du][P_3Du]": [
        "@~–kegpuk"
    ],
    "[V][Ptcp][Trns][A_1Du][P_3Pl]": [
        "@~–kepuk"
    ],
    "[V][Ptcp][Trns][A_1Du][P_3Sg]": [
        "@~–kevuk",
        "@~–kevvuk"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_2Du]": [
        "@~–kemcetek"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_2Pl]": [
        "@~–kemceci"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_2Sg]": [
        "@~–kemteggen"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_3Du]": [
        "@~–kegput"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_3Pl]": [
        "@~–keput"
    ],
    "[V][Ptcp][Trns][A_1Pl][P_3Sg]": [
        "@~–kevut",
        "@~–kevvut"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_2Du]": [
        "@~–kemtek"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_2Pl]": [
        "@~–kemci"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_2Sg]": [
        "@~–kemken"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_3Du]": [
        "@~–kegka"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_3Pl]": [
        "@~–kenka"
    ],
    "[V][Ptcp][Trns][A_1Sg][P_3Sg]": [
        "@~–keka"
    ],
    "[V][Ptcp][Trns][A_2Du][P_1Du]": [
        "@~–kevtegkuk"
    ],
    "[V][Ptcp][Trns][A_2Du][P_1Pl]": [
        "@~–kevtegkut"
    ],
    "[V][Ptcp][Trns][A_2Du][P_1Sg]": [
        "@~–kevtegnga"
    ],
    "[V][Ptcp][Trns][A_2Du][P_3Du]": [
        "@~–kegtek"
    ],
    "[V][Ptcp][Trns][A_2Du][P_3Pl]": [
        "@~–ketek"
    ],
    "[V][Ptcp][Trns][A_2Du][P_3Sg]": [
        "@~–kessek"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_1Du]": [
        "@~–kevcikuk"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_1Pl]": [
        "@~–kevcikut"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_1Sg]": [
        "@~–kevcia"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_3Du]": [
        "@~–kegci"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_3Pl]": [
        "@~–keci"
    ],
    "[V][Ptcp][Trns][A_2Pl][P_3Sg]": [
        "@~–kessi"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_1Du]": [
        "@~–kevkuk"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_1Pl]": [
        "@~–kevkut"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_1Sg]": [
        "@~–kevnga"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_3Du]": [
        "@~–kegken"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_3Pl]": [
        "@~–keten"
    ],
    "[V][Ptcp][Trns][A_2Sg][P_3Sg]": [
        "@~–ken"
    ],
    "[V][Ptcp][Trns][A_3Du][P_1Du]": [
        "@~–ke~iigkuk"
    ],
    "[V][Ptcp][Trns][A_3Du][P_1Pl]": [
        "@~–ke~iigkut"
    ],
    "[V][Ptcp][Trns][A_3Du][P_1Sg]": [
        "@~–ke~iignga"
    ],
    "[V][Ptcp][Trns][A_3Du][P_2Du]": [
        "@~–ke~iigtek"
    ],
    "[V][Ptcp][Trns][A_3Du][P_2Pl]": [
        "@~–ke~iigci"
    ],
    "[V][Ptcp][Trns][A_3Du][P_2Sg]": [
        "@~–ke~iigten"
    ],
    "[V][Ptcp][Trns][A_3Du][P_3Du]": [
        "@~–kegkek"
    ],
    "[V][Ptcp][Trns][A_3Du][P_3Pl]": [
        "@~–kekek"
    ],
    "[V][Ptcp][Trns][A_3Du][P_3Sg]": [
        "@~–ke~iik"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_1Du]": [
        "@~–ke~aitkuk"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_1Pl]": [
        "@~–ke~aitkut"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_1Sg]": [
        "@~–ke~iitnga"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_2Du]": [
        "@~–ke~aicetek"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_2Pl]": [
        "@~–ke~aiceci"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_2Sg]": [
        "@~–ke~iitgen"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_3Du]": [
        "@~–kegket"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_3Pl]": [
        "@~–ke~ait"
    ],
    "[V][Ptcp][Trns][A_3Pl][P_3Sg]": [
        "@~–ke~iit"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_1Du]": [
        "@~–ke~iikuk"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_1Pl]": [
        "@~–ke~iikut"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_1Sg]": [
        "@~–ke~iinga"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_2Du]": [
        "@~–ke~iitek"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_2Pl]": [
        "@~–ke~iici"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_2Sg]": [
        "@~–ke~iiten"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_3Du]": [
        "@~–kek"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_3Pl]": [
        "@~–ke~ai"
    ],
    "[V][Ptcp][Trns][A_3Sg][P_3Sg]": [
        "@~–ke~ii"
    ],
    "[V][Sbrd][Intr][S_1Du]": [
        "@~+lunuk",
        "@~+lunung",
        "@nanuk",
        "@nanung"
    ],
    "[V][Sbrd][Intr][S_1Pl]": [
        "@~+luta",
        "@nata"
    ],
    "[V][Sbrd][Intr][S_1Sg]": [
        "@~+lu:nga",
        "@na:nga"
    ],
    "[V][Sbrd][Intr][S_2Du]": [
        "@~+lutek",
        "@natek"
    ],
    "[V][Sbrd][Intr][S_2Pl]": [
        "@~+luci",
        "@naci"
    ],
    "[V][Sbrd][Intr][S_2Sg]": [
        "@~+luten",
        "@nak"
    ],
    "[V][Sbrd][Intr][S_4Du]": [
        "@~+lutek",
        "@natek"
    ],
    "[V][Sbrd][Intr][S_4Pl]": [
        "@~+luteng",
        "@nateng"
    ],
    "[V][Sbrd][Intr][S_4Sg]": [
        "@~+luni",
        "@nani"
    ],
    "[V][Sbrd][Trns][P_1Du]": [
        "@~+lunuk",
        "@~+lunung",
        "@nanuk",
        "@nanung"
    ],
    "[V][Sbrd][Trns][P_1Pl]": [
        "@~+luta",
        "@nata"
    ],
    "[V][Sbrd][Trns][P_1Sg]": [
        "@~+lu:nga",
        "@na:nga"
    ],
    "[V][Sbrd][Trns][P_2Du]": [
        "@~+lutek",
        "@natek"
    ],
    "[V][Sbrd][Trns][P_2Pl]": [
        "@~+luci",
        "@naci"
    ],
    "[V][Sbrd][Trns][P_2Sg]": [
        "@~+luten",
        "@naten"
    ],
    "[V][Sbrd][Trns][P_3Du]": [
        "@~+lukek",
        "@nakek"
    ],
    "[V][Sbrd][Trns][P_3Pl]": [
        "@~+luki",
        "@naki"
    ],
    "[V][Sbrd][Trns][P_3Sg]": [
        "@~+luku",
        "@naku"
    ],
    "[Via]": [
        ".ggun"
    ],
    "[Via][DuUnpd]": [
        ".negnun"
    ],
    "[Via][PlUnpd]": [
        ".tgun"
    ],
    "[Via][SgUnpd]": [
        ".kun"
    ],
    "[Voc][DuUnpd]": [
        ".uk"
    ],
    "[Voc][PlUnpd]": [
        ".ut"
    ],
    "[Voc][SgUnpd]": [
        "@+yuuq",
        "@+suuq"
    ],
"[Abl_Mod][1Du]":[""],
"[Abl_Mod][1Pl]":[""],
"[Abl_Mod][1Sg]":[""],
"[Abl_Mod][2Du]":[""],
"[Abl_Mod][2Pl]":[""],
"[Abl_Mod][2Sg]":[""],
"[Abl_Mod][3Du]":[""],
"[Abl_Mod][3Pl]":[""],
"[Abl_Mod][3Sg]":[""],
"[Abl_Mod][4Du]":[""],
"[Abl_Mod][4Pl]":[""],
"[Abl_Mod][4Sg]":[""],
"[Abs][1Du]":[""],
"[Abs][1Pl]":[""],
"[Abs][1Sg]":[""],
"[Abs][2Du]":[""],
"[Abs][2Pl]":[""],
"[Abs][2Sg]":[""],
"[Abs][3Du]":[""],
"[Abs][3Pl]":[""],
"[Abs][3Sg]":[""],
"[Abs][4Du]":[""],
"[Abs][4Pl]":[""],
"[Abs][4Sg]":[""],
"[Equ][1Du]":[""],
"[Equ][1Pl]":[""],
"[Equ][1Sg]":[""],
"[Equ][2Du]":[""],
"[Equ][2Pl]":[""],
"[Equ][2Sg]":[""],
"[Equ][3Du]":[""],
"[Equ][3Pl]":[""],
"[Equ][3Sg]":[""],
"[Equ][4Du]":[""],
"[Equ][4Pl]":[""],
"[Equ][4Sg]":[""],
"[Loc][1Du]":[""],
"[Loc][1Pl]":[""],
"[Loc][1Sg]":[""],
"[Loc][2Du]":[""],
"[Loc][2Pl]":[""],
"[Loc][2Sg]":[""],
"[Loc][3Du]":[""],
"[Loc][3Pl]":[""],
"[Loc][3Sg]":[""],
"[Loc][4Du]":[""],
"[Loc][4Pl]":[""],
"[Loc][4Sg]":[""],
"[Rel][1Du]":[""],
"[Rel][1Pl]":[""],
"[Rel][1Sg]":[""],
"[Rel][2Du]":[""],
"[Rel][2Pl]":[""],
"[Rel][2Sg]":[""],
"[Rel][3Du]":[""],
"[Rel][3Pl]":[""],
"[Rel][3Sg]":[""],
"[Rel][4Du]":[""],
"[Rel][4Pl]":[""],
"[Rel][4Sg]":[""],
"[Ter][1Du]":[""],
"[Ter][1Pl]":[""],
"[Ter][1Sg]":[""],
"[Ter][2Du]":[""],
"[Ter][2Pl]":[""],
"[Ter][2Sg]":[""],
"[Ter][3Du]":[""],
"[Ter][3Pl]":[""],
"[Ter][3Sg]":[""],
"[Ter][4Du]":[""],
"[Ter][4Pl]":[""],
"[Ter][4Sg]":[""],
"[Via][1Du]":[""],
"[Via][1Pl]":[""],
"[Via][1Sg]":[""],
"[Via][2Du]":[""],
"[Via][2Pl]":[""],
"[Via][2Sg]":[""],
"[Via][3Du]":[""],
"[Via][3Pl]":[""],
"[Via][3Sg]":[""],
"[Via][4Du]":[""],
"[Via][4Pl]":[""],
"[Via][4Sg]":[""],
}


// WEBPACK FOOTER //
// ./src/components/constants/ending_underlying.js